// import '@babel/polyfill';
import bx from "./bxslider/index.js";
import jQuery from "jquery";
import StickySidebar from "../node_modules/sticky-sidebar/src/sticky-sidebar.js";
import { alert } from "./alerts";

window.alerts = alert;

var lockSend = false;

let preloaderActive = true;
if (loadedPage != "" || localStorage.getItem("firstload") != null) {
	document.body.classList.add("hidePreloader");
}
const preloader = () => {
	jQuery(".loader-elems").addClass("active");
	var timeout = setTimeout(() => {
		if (preloaderActive == true) {
			preloader();
		} else {
			localStorage.setItem("firstload", 1);
			document.body.classList.add("hidePreloader");
			clearTimeout(timeout);
			console.warn("LOADER HIDDEN");
		}
	}, 2000);
};
preloader();

function date(format, timestamp) {
	//  discuss at: http://locutus.io/php/date/
	// original by: Carlos R. L. Rodrigues (http://www.jsfromhell.com)
	// original by: gettimeofday
	//    parts by: Peter-Paul Koch (http://www.quirksmode.org/js/beat.html)
	// improved by: Kevin van Zonneveld (http://kvz.io)
	// improved by: MeEtc (http://yass.meetcweb.com)
	// improved by: Brad Touesnard
	// improved by: Tim Wiel
	// improved by: Bryan Elliott
	// improved by: David Randall
	// improved by: Theriault (https://github.com/Theriault)
	// improved by: Theriault (https://github.com/Theriault)
	// improved by: Brett Zamir (http://brett-zamir.me)
	// improved by: Theriault (https://github.com/Theriault)
	// improved by: Thomas Beaucourt (http://www.webapp.fr)
	// improved by: JT
	// improved by: Theriault (https://github.com/Theriault)
	// improved by: Rafał Kukawski (http://blog.kukawski.pl)
	// improved by: Theriault (https://github.com/Theriault)
	//    input by: Brett Zamir (http://brett-zamir.me)
	//    input by: majak
	//    input by: Alex
	//    input by: Martin
	//    input by: Alex Wilson
	//    input by: Haravikk
	// bugfixed by: Kevin van Zonneveld (http://kvz.io)
	// bugfixed by: majak
	// bugfixed by: Kevin van Zonneveld (http://kvz.io)
	// bugfixed by: Brett Zamir (http://brett-zamir.me)
	// bugfixed by: omid (http://locutus.io/php/380:380#comment_137122)
	// bugfixed by: Chris (http://www.devotis.nl/)
	//      note 1: Uses global: locutus to store the default timezone
	//      note 1: Although the function potentially allows timezone info
	//      note 1: (see notes), it currently does not set
	//      note 1: per a timezone specified by date_default_timezone_set(). Implementers might use
	//      note 1: $locutus.currentTimezoneOffset and
	//      note 1: $locutus.currentTimezoneDST set by that function
	//      note 1: in order to adjust the dates in this function
	//      note 1: (or our other date functions!) accordingly
	//   example 1: date('H:m:s \\m \\i\\s \\m\\o\\n\\t\\h', 1062402400)
	//   returns 1: '07:09:40 m is month'
	//   example 2: date('F j, Y, g:i a', 1062462400)
	//   returns 2: 'September 2, 2003, 12:26 am'
	//   example 3: date('Y W o', 1062462400)
	//   returns 3: '2003 36 2003'
	//   example 4: var $x = date('Y m d', (new Date()).getTime() / 1000)
	//   example 4: $x = $x + ''
	//   example 4: var $result = $x.length // 2009 01 09
	//   returns 4: 10
	//   example 5: date('W', 1104534000)
	//   returns 5: '52'
	//   example 6: date('B t', 1104534000)
	//   returns 6: '999 31'
	//   example 7: date('W U', 1293750000.82); // 2010-12-31
	//   returns 7: '52 1293750000'
	//   example 8: date('W', 1293836400); // 2011-01-01
	//   returns 8: '52'
	//   example 9: date('W Y-m-d', 1293974054); // 2011-01-02
	//   returns 9: '52 2011-01-02'
	//        test: skip-1 skip-2 skip-5

	var jsdate, f;
	// Keep this here (works, but for code commented-out below for file size reasons)
	// var tal= [];
	var txtWords = [
		"Sun",
		"Mon",
		"Tues",
		"Wednes",
		"Thurs",
		"Fri",
		"Satur",
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	];
	// trailing backslash -> (dropped)
	// a backslash followed by any character (including backslash) -> the character
	// empty string -> empty string
	var formatChr = /\\?(.?)/gi;
	var formatChrCb = function (t, s) {
		return f[t] ? f[t]() : s;
	};
	var _pad = function (n, c) {
		n = String(n);
		while (n.length < c) {
			n = "0" + n;
		}
		return n;
	};
	f = {
		// Day
		d: function () {
			// Day of month w/leading 0; 01..31
			return _pad(f.j(), 2);
		},
		D: function () {
			// Shorthand day name; Mon...Sun
			return f.l().slice(0, 3);
		},
		j: function () {
			// Day of month; 1..31
			return jsdate.getDate();
		},
		l: function () {
			// Full day name; Monday...Sunday
			return txtWords[f.w()] + "day";
		},
		N: function () {
			// ISO-8601 day of week; 1[Mon]..7[Sun]
			return f.w() || 7;
		},
		S: function () {
			// Ordinal suffix for day of month; st, nd, rd, th
			var j = f.j();
			var i = j % 10;
			if (i <= 3 && parseInt((j % 100) / 10, 10) === 1) {
				i = 0;
			}
			return ["st", "nd", "rd"][i - 1] || "th";
		},
		w: function () {
			// Day of week; 0[Sun]..6[Sat]
			return jsdate.getDay();
		},
		z: function () {
			// Day of year; 0..365
			var a = new Date(f.Y(), f.n() - 1, f.j());
			var b = new Date(f.Y(), 0, 1);
			return Math.round((a - b) / 864e5);
		},

		// Week
		W: function () {
			// ISO-8601 week number
			var a = new Date(f.Y(), f.n() - 1, f.j() - f.N() + 3);
			var b = new Date(a.getFullYear(), 0, 4);
			return _pad(1 + Math.round((a - b) / 864e5 / 7), 2);
		},

		// Month
		F: function () {
			// Full month name; January...December
			return txtWords[6 + f.n()];
		},
		m: function () {
			// Month w/leading 0; 01...12
			return _pad(f.n(), 2);
		},
		M: function () {
			// Shorthand month name; Jan...Dec
			return f.F().slice(0, 3);
		},
		n: function () {
			// Month; 1...12
			return jsdate.getMonth() + 1;
		},
		t: function () {
			// Days in month; 28...31
			return new Date(f.Y(), f.n(), 0).getDate();
		},

		// Year
		L: function () {
			// Is leap year?; 0 or 1
			var j = f.Y();
			return ((j % 4 === 0) & (j % 100 !== 0)) | (j % 400 === 0);
		},
		o: function () {
			// ISO-8601 year
			var n = f.n();
			var W = f.W();
			var Y = f.Y();
			return Y + (n === 12 && W < 9 ? 1 : n === 1 && W > 9 ? -1 : 0);
		},
		Y: function () {
			// Full year; e.g. 1980...2010
			return jsdate.getFullYear();
		},
		y: function () {
			// Last two digits of year; 00...99
			return f.Y().toString().slice(-2);
		},

		// Time
		a: function () {
			// am or pm
			return jsdate.getHours() > 11 ? "pm" : "am";
		},
		A: function () {
			// AM or PM
			return f.a().toUpperCase();
		},
		B: function () {
			// Swatch Internet time; 000..999
			var H = jsdate.getUTCHours() * 36e2;
			// Hours
			var i = jsdate.getUTCMinutes() * 60;
			// Minutes
			// Seconds
			var s = jsdate.getUTCSeconds();
			return _pad(Math.floor((H + i + s + 36e2) / 86.4) % 1e3, 3);
		},
		g: function () {
			// 12-Hours; 1..12
			return f.G() % 12 || 12;
		},
		G: function () {
			// 24-Hours; 0..23
			return jsdate.getHours();
		},
		h: function () {
			// 12-Hours w/leading 0; 01..12
			return _pad(f.g(), 2);
		},
		H: function () {
			// 24-Hours w/leading 0; 00..23
			return _pad(f.G(), 2);
		},
		i: function () {
			// Minutes w/leading 0; 00..59
			return _pad(jsdate.getMinutes(), 2);
		},
		s: function () {
			// Seconds w/leading 0; 00..59
			return _pad(jsdate.getSeconds(), 2);
		},
		u: function () {
			// Microseconds; 000000-999000
			return _pad(jsdate.getMilliseconds() * 1000, 6);
		},

		// Timezone
		e: function () {
			// Timezone identifier; e.g. Atlantic/Azores, ...
			// The following works, but requires inclusion of the very large
			// timezone_abbreviations_list() function.
			/*              return that.date_default_timezone_get();
			 */
			var msg =
				"Not supported (see source code of date() for timezone on how to add support)";
			throw new Error(msg);
		},
		I: function () {
			// DST observed?; 0 or 1
			// Compares Jan 1 minus Jan 1 UTC to Jul 1 minus Jul 1 UTC.
			// If they are not equal, then DST is observed.
			var a = new Date(f.Y(), 0);
			// Jan 1
			var c = Date.UTC(f.Y(), 0);
			// Jan 1 UTC
			var b = new Date(f.Y(), 6);
			// Jul 1
			// Jul 1 UTC
			var d = Date.UTC(f.Y(), 6);
			return a - c !== b - d ? 1 : 0;
		},
		O: function () {
			// Difference to GMT in hour format; e.g. +0200
			var tzo = jsdate.getTimezoneOffset();
			var a = Math.abs(tzo);
			return (
				(tzo > 0 ? "-" : "+") + _pad(Math.floor(a / 60) * 100 + (a % 60), 4)
			);
		},
		P: function () {
			// Difference to GMT w/colon; e.g. +02:00
			var O = f.O();
			return O.substr(0, 3) + ":" + O.substr(3, 2);
		},
		T: function () {
			// The following works, but requires inclusion of the very
			// large timezone_abbreviations_list() function.
			/*              var abbr, i, os, _default;
            if (!tal.length) {
              tal = that.timezone_abbreviations_list();
            }
            if ($locutus && $locutus.default_timezone) {
              _default = $locutus.default_timezone;
              for (abbr in tal) {
                for (i = 0; i < tal[abbr].length; i++) {
                  if (tal[abbr][i].timezone_id === _default) {
                    return abbr.toUpperCase();
                  }
                }
              }
            }
            for (abbr in tal) {
              for (i = 0; i < tal[abbr].length; i++) {
                os = -jsdate.getTimezoneOffset() * 60;
                if (tal[abbr][i].offset === os) {
                  return abbr.toUpperCase();
                }
              }
            }
            */
			return "UTC";
		},
		Z: function () {
			// Timezone offset in seconds (-43200...50400)
			return -jsdate.getTimezoneOffset() * 60;
		},

		// Full Date/Time
		c: function () {
			// ISO-8601 date.
			return "Y-m-d\\TH:i:sP".replace(formatChr, formatChrCb);
		},
		r: function () {
			// RFC 2822
			return "D, d M Y H:i:s O".replace(formatChr, formatChrCb);
		},
		U: function () {
			// Seconds since UNIX epoch
			return (jsdate / 1000) | 0;
		},
	};

	var _date = function (format, timestamp) {
		jsdate =
			timestamp === undefined
				? new Date() // Not provided
				: timestamp instanceof Date
				? new Date(timestamp) // JS Date()
				: new Date(timestamp * 1000); // UNIX timestamp (auto-convert to int)
		return format.replace(formatChr, formatChrCb);
	};

	return _date(format, timestamp);
}

function run($elm, v, time, dones) {
	$(v[0]).animate(v[1], {
		duration: time,
		step: function (val) {
			$elm.css("transform", `translateY(${val}%)`);
		},
		done: function () {
			dones ? dones.call(this) : null;
		},
	});
}
let mobileCostTimer;
const animChange = async (counter) => {
	let cartNow = counter;
	if (!counter) {
		const { data } = await getCart();
		cartNow = data;
	}
	const elem = $(
		"body>header>.hide_header>nav .cart:not(.mobile) .show, body>header>.show_header>nav .cart:not(.mobile) .show, .search_modal .search_cart .show"
	);
	run(
		elem,
		[
			{
				y: -50,
			},
			{
				y: 300,
			},
		],
		200,
		() => {
			elem.html("(" + (cartNow.length || 0) + ")");
			elem.css("transform", "translate(0px,-300%)");
			run(
				elem,
				[
					{
						y: -300,
					},
					{
						y: -50,
					},
				],
				200
			);
		}
	);
	$(
		"body>header>.hide_header .cart.mobile .show, body>header>.show_header .cart.mobile .show, .search_modal .search_cart .show"
	).html(cartNow.length || 0);
	if (mobileCostTimer) {
		clearTimeout(mobileCostTimer);
	}
	mobileCostTimer = setTimeout(() => {
		$("body>header>.show_header>.second .cart_mobile .cart").removeClass(
			"active-btn"
		);
	}, 1200);
	let { allCost, allDiscount } = renderAjax(
		cartNow,
		$(".cart+.mini-cart .contain")
	);
	console.warn("allCost", allCost);
	window.totalOrderPrice = allCost;
	// for(let p = 0; p < $(".products .elem").length; p++) {
	//     if($(".products .elem").eq(p).attr("data-product-tip") == "SALE") {
	//         pickupSale = false;
	//         break;
	//     } else {
	//         pickupSale = true;
	//     }
	// }
	// $(".cart+.mini-cart .bottom .price .cost b.uah, .product-view.order>.right .total .head .total_cart b.uah, .product-view.order>.conain>.right .total .head .total_cart b.uah").html((allCost/window.rubData).toFixed(0));
	// $(".cart+.mini-cart .bottom .price .cost b.rub, .product-view.order>.right .total .head .total_cart b.rub, .product-view.order>.conain>.right .total .head .total_cart b.rub").html(allCost);
	// if($("#pickup").prop("checked") && pickupSale) {
	//     pickupCalc();
	// }
	$(
		".cart+.mini-cart .bottom .price .cost b, .product-view.order>.right .total .head .total_cart b, .product-view.order>.conain>.right .total .head .total_cart b"
	).html(allCost);
};

let heightNav = 0;
let cartLast;
window.scrollTopProduct = {};
const closeMobileMenu = () => {
	menuActive
		? $("body>header>.show_header>nav").removeClass("active") &&
		  anim.reverse() &&
		  $("body>header>.show_header>nav").removeClass("show-menu")
		: false;
};
const toggleMobileMenu = (close) => {
	menuActive
		? $("body>header>.show_header>nav").removeClass("active") &&
		  anim.reverse() &&
		  $("body>header>.show_header>nav").removeClass("show-menu")
		: $("body>header>.show_header>nav").addClass("active") &&
		  $("body>header>.show_header>nav").addClass("show-menu") &&
		  anim.play();
};
const activeMenu = () => {
	var t = $("#cardinalParams")
		.html()
		.replace(new RegExp("var (.+?) = (.+?);", "g"), '"$1":$2,')
		.trim();
	eval("window.ajaxLoadParam = {" + t.substr(0, t.length - 1) + "}");

	$(
		"body>header>.show_header>nav>ul>li,body>header>.hide_header>nav>ul>li"
	).removeClass("active");
	if (
		window.ajaxLoadParam.loadedParam.method == "list_akcii" ||
		window.ajaxLoadParam.loadedParam.method == "details_akcii"
	) {
		$(
			"body>header>.show_header>nav>ul>li:nth-child(4),body>header>.hide_header>nav>ul>li:nth-child(3)"
		).addClass("active");
	} else if (
		window.ajaxLoadParam.loadedParam.method == "category" ||
		window.ajaxLoadParam.loadedParam.method == "product"
	) {
		$(
			"body>header>.show_header>nav>ul>li:nth-child(5),body>header>.hide_header>nav>ul>li:nth-child(4)"
		).addClass("active");
	} else if (window.ajaxLoadParam.loadedParam.method == "delivery") {
		$(
			"body>header>.show_header>nav>ul>li:nth-child(6),body>header>.hide_header>nav>ul>li:nth-child(5)"
		).addClass("active");
	} else if (window.ajaxLoadParam.loadedParam.template == "contacts") {
		$(
			"body>header>.show_header>nav>ul>li:nth-child(7),body>header>.hide_header>nav>ul>li:nth-child(6)"
		).addClass("active");
	} else if (window.ajaxLoadParam.loadedParam.method == "reviews") {
		$(
			"body>header>.show_header>nav>ul>li:nth-child(9),body>header>.hide_header>nav>ul>li:nth-child(8)"
		).addClass("active");
	} else if (window.ajaxLoadParam.loadedParam.method == "oferta") {
		$(
			"body>header>.show_header>nav>ul>li:nth-child(8),body>header>.hide_header>nav>ul>li:nth-child(7)"
		).addClass("active");
	} else {
		$(
			"body>header>.show_header>nav>ul>li:nth-child(3),body>header>.hide_header>nav>ul>li:nth-child(2)"
		).addClass("active");
	}
};
const changeLocation = (link) => {
	$(".cart+.mini-cart").removeClass("active");
	menuActive
		? $("body>header>.show_header>nav").removeClass("active") &&
		  anim.reverse() &&
		  $("body>header>.show_header>nav").removeClass("show-menu")
		: false;
	(async (link) => {
		//loadedParam
		await removeFilter({
			filter: "all",
		});
		if (typeof window.filters !== "undefined") {
			delete window.filters;
		}
		if ($(".category_page .left").length == 0) {
			$("html,body").animate(
				{
					scrollTop: 0,
				},
				300
			);
		} else {
			$("html,body").animate(
				{
					scrollTop: $(".catalog-products").offset().top - 120,
				},
				1200
			);
		}
		const resp = await fetch(link);
		const parse = await resp.text();
		const html = $("<div/>").html(parse);
		console.log($("title", html));
		$("title").html($("title", html).html());
		const params = $("#cardinalParams", html)
			.html()
			.match(/var loadedParam = (.+?)\;/g);
		const json =
			typeof params[0] !== "undefined"
				? JSON.parse(params[0].replace(/var loadedParam = (.+?)\;/g, "$1"))
				: "";
		const method = typeof json.method !== "undefined" ? json.method : "";
		$("body").attr("class", method + " hidePreloader");
		$("article").html($("article", html).html());
		$("#cardinalParams").html($("#cardinalParams", html).html());
		activeMenu();
		readyDoc();
		shopReinit();
	})(link);
};
const activatedAttrsBtn = () => {
	(async () => {
		$(
			".product-view>*>.left .container .info .attrs span, .product-view>.left .container .info .attrs span"
		)
			.first()
			.addClass("active");
		const elemAttr1 = $(
			".product-view>*>.left .container .info .attrs span, .product-view>.left .container .info .attrs span"
		).first();
		if (elemAttr1[0]) {
			$(
				".product-view>*>.left .container .info .add-to-cart .button, .product-view>.left .container .info .add-to-cart .button"
			).attr("product-attr", elemAttr1.attr("data-attr"));
			// $(".product-view>*>.left .container .info .add-to-cart .button, .product-view>.left .container .info .add-to-cart .button").attr("product-attr", elemAttr1.attr("data-attr"))
			const weight2 = $(
				".product-view>*>.left .container .info .attrs span, .product-view>.left .container .info .attrs span"
			)
				.first()
				.html();
			weight2 &&
				$(
					".product-view>*>.left .container .info .weight, .product-view>.left .container .info .weight"
				).html(weight2);
			// $(".product-view>*>.left .container .info .prices .price b, .product-view>.left .container .info .prices .price b").html(elemAttr1.attr("data-price"))
			// $(".product-view>*>.left .container .info .prices .price b, .product-view>.left .container .info .prices .rub b").html((parseFloat(elemAttr1.attr("data-price"))/window.rubData).toFixed(0))
			$(
				".product-view>*>.left .container .info .prices .price b, .product-view>.left .container .info .prices .price b"
			).html(elemAttr1.attr("data-price"));
		} else {
			$(".product-item").each(function (i, elem) {
				const elemAttr2 = $(elem).find(".zIndex2 .attrs span").first();
				console.warn($(elem).find(".zIndex2 .attrs span"));
				if (elemAttr2[0]) {
					elemAttr2.addClass("active");
					$(elem)
						.find(".info span.btn")
						.attr("product-attr", elemAttr2.attr("data-attr"));
					const costPrice = elemAttr2.attr("data-price");
					$(elem).find(".info .price b").html(costPrice);
					//$(elem).find(".info .rub b").html((parseFloat(costPrice)/window.rubData).toFixed(0))
				}
			});
		}
	})();
	var id = $(".product-view>.left .container .info .attrs .btn.active").attr(
		"data-attr"
	);
	$(".product-view>.left .addition_product .btn[data-additionals-size]").hide();
	$(
		".product-view>.left .addition_product .btn[data-additionals-size='" +
			id +
			"']"
	).show();
	$(".product-item").each(function (i, elem) {
		var id = $(elem).find(".zIndex2 .attrs span.active").attr("data-attr");
		$(elem)
			.find(".zIndex2 .addition_product .btn[data-additionals-size]")
			.hide();
		$(elem)
			.find(
				".zIndex2 .addition_product .btn[data-additionals-size='" + id + "']"
			)
			.show();
	});
	$(".product-view>.left .container .info .attrs .btn").click(function () {
		var id = $(this).attr("data-attr");
		$(".addition_product .btn[data-additionals-size]").hide();
		$(".addition_product .btn[data-additionals-size='" + id + "']").show();
		$(".addition_product .btn").removeClass("active");
		//$(".product-view>*>.left .container .info .prices .price b, .product-view>.left .container .info .prices .price b,.product-view>*>.left .container .info .prices .rub b, .product-view>.left .container .info .prices .rub b").removeAttr("data-or-price");
		$(
			".product-view>*>.left .container .info .prices .price b, .product-view>.left .container .info .prices .price b"
		).removeAttr("data-or-price");
	});
	$(".product-item .zIndex2 .attrs .btn").click(function () {
		var id = $(this).attr("data-attr");
		$(this)
			.parents(".product-item")
			.find(".addition_product .btn[data-additionals-size]")
			.hide();
		$(this)
			.parents(".product-item")
			.find(".addition_product .btn[data-additionals-size='" + id + "']")
			.show();
		$(this)
			.parents(".product-item")
			.find(".addition_product .btn")
			.removeClass("active");
		$(this)
			.parents(".product-item")
			.find(".zIndex2 .info .price b")
			.removeAttr("data-or-price");
	});
	$("body")
		.off("click", ".addition_product .btn")
		.on("click", ".addition_product .btn", function (e) {
			e.preventDefault();
			if ($(this).hasClass("active")) {
				$(this)
					.parents(".info,.product-item")
					.find(".addition_product .btn")
					.removeClass("active");
				$(this)
					.parents(".info,.product-item")
					.find("#button-cart,.info .btn")
					.removeAttr("product-additionals");
				$(this)
					.parents(".product-item")
					.find(".price b")
					.each(function (i, elem) {
						if (!$(elem).attr("data-or-price")) {
							$(elem).attr("data-or-price", $(elem).html());
							var priceProduct = parseFloat($(elem).html());
						} else {
							var priceProduct = parseFloat($(elem).attr("data-or-price"));
						}
						$(elem).html(priceProduct.toFixed(0));
					});
				$(this)
					.parents(".product-item")
					.find(".rub b")
					.each(function (i, elem) {
						if (!$(elem).attr("data-or-price")) {
							$(elem).attr("data-or-price", $(elem).html());
							var priceProduct = parseFloat($(elem).html());
						} else {
							var priceProduct = parseFloat($(elem).attr("data-or-price"));
						}
						$(elem).html(priceProduct.toFixed(0));
					});
				$(
					".product-view>*>.left .container .info .prices .price b, .product-view>.left .container .info .prices .price b"
				).each(function (i, elem) {
					if (!$(elem).attr("data-or-price")) {
						$(elem).attr("data-or-price", $(elem).html());
						var priceProduct = parseFloat($(elem).html());
					} else {
						var priceProduct = parseFloat($(elem).attr("data-or-price"));
					}
					$(elem).html(priceProduct.toFixed(0));
				});
				$(
					".product-view>*>.left .container .info .prices .rub b, .product-view>.left .container .info .prices .rub b"
				).each(function (i, elem) {
					if (!$(elem).attr("data-or-price")) {
						$(elem).attr("data-or-price", $(elem).html());
						var priceProduct = parseFloat($(elem).html());
					} else {
						var priceProduct = parseFloat($(elem).attr("data-or-price"));
					}
					$(elem).html(priceProduct.toFixed(0));
				});
			} else {
				$(this)
					.parents(".info,.product-item")
					.find(".addition_product .btn")
					.removeClass("active");
				var elementAdditional = $(this);
				elementAdditional.addClass("active");
				var first = elementAdditional.attr("data-additionals");
				elementAdditional
					.parents(".info,.product-item")
					.find("#button-cart,.info .btn")
					.attr("product-additionals", first);
				elementAdditional
					.parents(".product-item")
					.find(".price b")
					.each(function (i, elem) {
						if (!$(elem).attr("data-or-price")) {
							$(elem).attr("data-or-price", $(elem).html());
							var priceProduct = parseFloat($(elem).html());
						} else {
							var priceProduct = parseFloat($(elem).attr("data-or-price"));
						}
						var valuePrice = elementAdditional.attr("data-additionals-price");
						if (valuePrice.substring(0, 1) == "-") {
							valuePrice = -parseFloat(
								valuePrice.replace(new RegExp("[^0-9]", "g"), "")
							);
						} else {
							valuePrice = parseFloat(
								valuePrice.replace(new RegExp("[^0-9]", "g"), "")
							);
						}
						console.log("priceProduct", priceProduct, valuePrice);
						$(elem).html((priceProduct + valuePrice).toFixed(0));
					});
				elementAdditional
					.parents(".product-item")
					.find(".rub b")
					.each(function (i, elem) {
						if (!$(elem).attr("data-or-price")) {
							$(elem).attr("data-or-price", $(elem).html());
							var priceProduct = parseFloat($(elem).html());
						} else {
							var priceProduct = parseFloat($(elem).attr("data-or-price"));
						}
						var valuePrice = elementAdditional.attr("data-additionals-price");
						if (valuePrice.substring(0, 1) == "-") {
							valuePrice = -parseFloat(
								valuePrice.replace(new RegExp("[^0-9]", "g"), "")
							);
						} else {
							valuePrice = parseFloat(
								valuePrice.replace(new RegExp("[^0-9]", "g"), "")
							);
						}
						console.log("priceProduct", priceProduct, valuePrice);
						$(elem).html(
							priceProduct + Math.round(valuePrice / window.rubData)
						);
					});
				$(
					".product-view>*>.left .container .info .prices .price b, .product-view>.left .container .info .prices .price b"
				).each(function (i, elem) {
					if (!$(elem).attr("data-or-price")) {
						$(elem).attr("data-or-price", $(elem).html());
						var priceProduct = parseFloat($(elem).html());
					} else {
						var priceProduct = parseFloat($(elem).attr("data-or-price"));
					}
					var valuePrice = $(".btn-additionals.active").attr(
						"data-additionals-price"
					);
					if (valuePrice.substring(0, 1) == "-") {
						valuePrice = -parseFloat(
							valuePrice.replace(new RegExp("[^0-9]", "g"), "")
						);
					} else {
						valuePrice = parseFloat(
							valuePrice.replace(new RegExp("[^0-9]", "g"), "")
						);
					}
					console.log(
						"priceProduct",
						priceProduct,
						valuePrice,
						priceProduct + valuePrice,
						$(elem)
					);
					$(elem).html((priceProduct + valuePrice).toFixed(0));
				});
				$(
					".product-view>*>.left .container .info .prices .rub b, .product-view>.left .container .info .prices .rub b"
				).each(function (i, elem) {
					if (!$(elem).attr("data-or-price")) {
						$(elem).attr("data-or-price", $(elem).html());
						var priceProduct = parseFloat($(elem).html());
					} else {
						var priceProduct = parseFloat($(elem).attr("data-or-price"));
					}
					var valuePrice = $(".btn-additionals.active").attr(
						"data-additionals-price"
					);
					if (valuePrice.substring(0, 1) == "-") {
						valuePrice = -parseFloat(
							valuePrice.replace(new RegExp("[^0-9]", "g"), "")
						);
					} else {
						valuePrice = parseFloat(
							valuePrice.replace(new RegExp("[^0-9]", "g"), "")
						);
					}
					console.log(
						"priceProduct",
						priceProduct,
						valuePrice,
						priceProduct + valuePrice,
						$(elem)
					);
					$(elem).html(priceProduct + Math.round(valuePrice / window.rubData));
				});
			}
			return false;
		});
};
(async () => {
	function getCart() {
		return new Promise(function (resolve, reject) {
			var attrs = {};
			attrs["type"] = "cartList";
			try {
				fetch(default_link + main_page_lang + "ajaxLoad", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(attrs),
				})
					.then(function (resp) {
						return resp.json();
					})
					.then(function (data) {
						triggerEvent("cartList", data);
						resolve(data);
					})
					.catch(function (e) {
						reject(e);
						triggerEvent("cartErrorList", e);
					});
			} catch (e) {
				reject(e);
				triggerEvent("cartErrorList", e);
			}
		});
	}
	const { data } = await getCart();
	animChange(data);
})();
const readyDoc = async function () {
	const notAjaxGo = [
		"[href='']",
		"[href='#']",
		".more-btn",
		//"[data-cat]"
	];
	const notAjaxGoMap = notAjaxGo.map((el) => `:not(${el})`);
	const notAjaxGoJoin = notAjaxGoMap.join("");
	$(window)
		.off("popstate")
		.on("popstate", (e) => {
			e.preventDefault();
			changeLocation(window.location.href);
		});
	console.log(
		`article a${notAjaxGoJoin}, header a${notAjaxGoJoin}, footer a${notAjaxGoJoin}`
	);
	/*$("body").off("click", `article a${notAjaxGoJoin}, header a${notAjaxGoJoin}, footer a${notAjaxGoJoin}`).on("click", `article a${notAjaxGoJoin}, header a${notAjaxGoJoin}, footer a${notAjaxGoJoin}`, (e) => {
        if(e.target.closest(".productCounter")!=null || e.target.className.indexOf("productCounter")>-1) {
            return;
        }
        if(e.target.closest("nav .cart, nav .cart")!=null || e.target.className.indexOf("cart")>-1) {
            return;
        }
        if (e.target.closest(".product") != null || e.target.className.indexOf("product") > -1) {
            return;
        }
        if (e.target.closest(".slide") != null || e.target.className.indexOf("slide") > -1) {
            return;
        }
        if (e.target.closest(".show_header") != null || e.target.className.indexOf("show_header") > -1) {
            return;
        }
        if(e.target.closest("nav .mini-cart .contain-cart .contain")!=null || e.target.className.indexOf("contain")>-1) {
            return;
        }
        if(e.target.closest(".more a")!=null) {
            return;
        }
        if(e.target.closest("[data-add-to-cart]")!=null || e.target.getAttribute("data-add-to-cart")!=null) {
            return;
        }
        if(e.target.closest(".quantity")!=null) {
            return;
        }
        if(e.target.closest(".category_page .categories a.active")!=null) {
            return;
        }
        if(e.target.closest(".catalog-products.index .category a.active")!=null) {
            return;
        }
        console.log(e);
        const link = $(e.target.closest(`a`)).attr("href");
        window.history.pushState({}, "", link);
        changeLocation(link);
        return false;
    })*/
	$(".catalog-products .products .more a")
		.off("click")
		.on("click", (e) => {
			e.preventDefault();
			var elem = $(".catalog-products .products .list");
			pageNow++;
			let builderFilters = [];
			Object.keys(window.filters).forEach((name) => {
				const key = Object.keys(window.filters[name])[0];
				builderFilters[builderFilters.length] =
					name + "=" + window.filters[name][key];
			});
			loadProducts(elem, "more", builderFilters.join("&"));
		});
	if (typeof window.currentCategory !== "undefined") {
		window.filters = {};
		window.filters["Kategoriya"] = {};
		window.filters["Kategoriya"][`${window.currentCategory}`] =
			window.currentCategory;
	} else {
		window.filters = { Kategoriya: { 1: 1 } };
	}
	console.warn("1234567");
	$(".catalog .category a,.catalog-products .onMobileHover a")
		.off("click")
		.on("click", (e) => {
			e.preventDefault();
			(async (e) => {
				pageNow = 1;
				/*await removeFilter({
                filter: `all`
            });*/
				console.log("LOADING START");
				$("body").addClass("productsloading");
				let elemSelect;
				elemSelect = $(e.target);
				let cat = elemSelect.attr("data-cat");
				if (!cat) {
					elemSelect = $(e.target).parents(".category a");
					cat = elemSelect.attr("data-cat");
				}

				let btnTpl =
					'<a href="#" data-alt-name="{alt_nazvanie}" data-cat="{sId}" data-parent-id="{Roditelskaya_kategoriya}"{active} data-my-id="{id}"><span></span><div>{Nazvanie}</div></a><style>.catalog-products .menu .sidebar__inner a[data-my-id="{id}"] span:after { content: ""; background: url(\'{img}\') no-repeat 50%; background-size: contain; width: 3.8em; font-size:1em; height: 3em; display: block; }.catalog-products .menu .sidebar__inner a[data-my-id="{id}"]:hover span:after { filter: invert(1) brightness(200); }</style>';
				if (typeof $(".category_page .categories")[0] !== "undefined") {
					btnTpl =
						'<a href="{link}" data-alt-name="{alt_nazvanie}" data-id="{sId}" data-parent-id="{Roditelskaya_kategoriya}" {active}><div class="block"><div class="img"><img src="{img}"></div><div class="name">{Nazvanie}</div></div></a>';
				}

				let tmp = "";
				let i = 0;
				const data = await getSubCat(cat);
				const row = data.data;
				let tpl = btnTpl.replace(new RegExp("{sId}", "g"), row.sId);
				tpl = tpl.replace(new RegExp("{alt_nazvanie}", "g"), row.alt_nazvanie);
				tpl = tpl.replace(
					new RegExp("{Roditelskaya_kategoriya}", "g"),
					row.Roditelskaya_kategoriya
				);
				tpl = tpl.replace(new RegExp("{Nazvanie}", "g"), row.Nazvanie);
				tpl = tpl.replace(new RegExp("{active}", "g"), ' class="active"');
				tpl = tpl.replace(
					new RegExp("{img}", "g"),
					default_link + row.Kartinka
				);
				tpl = tpl.replace(
					new RegExp("{link}", "g"),
					category_link_route.replace("testtesttesttest", row.alt_nazvanie)
				);
				tpl = tpl.replace(new RegExp("{id}", "g"), i + 1);
				tmp += tpl;
				i++;
				if (typeof row.children !== "undefined") {
					for (let is = 0; is < row.children.length; is++) {
						tpl = btnTpl.replace(
							new RegExp("{sId}", "g"),
							row.children[is].sId
						);
						tpl = tpl.replace(
							new RegExp("{alt_nazvanie}", "g"),
							row.children[is].alt_nazvanie
						);
						tpl = tpl.replace(
							new RegExp("{Roditelskaya_kategoriya}", "g"),
							row.children[is].Roditelskaya_kategoriya
						);
						tpl = tpl.replace(
							new RegExp("{Nazvanie}", "g"),
							row.children[is].Nazvanie
						);
						tpl = tpl.replace(
							new RegExp("{active}", "g"),
							typeof row.children[is].active !== "undefined"
								? ' class="active"'
								: ""
						);
						tpl = tpl.replace(
							new RegExp("{img}", "g"),
							default_link + row.children[is].Kartinka
						);
						tpl = tpl.replace(
							new RegExp("{link}", "g"),
							sub_category_link_route
								.replace("testtesttesttest1", row.alt_nazvanie)
								.replace("testtesttesttest2", row.children[is].alt_nazvanie)
						);
						tpl = tpl.replace(new RegExp("{id}", "g"), i + 1);
						tmp += tpl;
						i++;
					}
				}
				$(
					".catalog-products .menu .sidebar__inner,.category_page .categories"
				).html(tmp);

				elemSelect.parents(".category").find("a").removeClass("active");
				elemSelect.addClass("active");
				window.filters["Kategoriya"] = {};
				window.filters["Kategoriya"]["" + cat] = 1;
				$(".catalog-products .products .list").html("");
				var elem = $(".catalog-products .products .list");
				loadProducts(
					elem,
					"onMobileHover",
					{ resetFilter: true, Kategoriya: cat },
					{
						page: pageNow,
						max: window.doLoadMax,
					}
				);
				$("body").removeClass("productsloading");

				tmp = '<a href="#" class="active removeFilter">Все</a>';
				console.warn(tmp);
				$(".catalog .meta .container").html(tmp);
			})(e);
		});
	// $("body").off("click", ".catalog-products .menu .sidebar__inner a").on("click", ".catalog-products .menu .sidebar__inner a", (e) => {
	//     if(!($(e.target).is(".catalog-products .menu .sidebar__inner a") || e.target.closest(".catalog-products .menu .sidebar__inner a"))) {
	//         return false;
	//     }
	//     e.preventDefault();
	//     const elem = ($(e.target).is(".catalog-products .menu .sidebar__inner a") ? e.target : e.target.closest(".catalog-products .menu .sidebar__inner a"));
	//     console.warn($(e.target).is(".catalog-products .menu .sidebar__inner a"), elem);
	//     (async () => {
	//         console.warn(elem);
	//         pageNow = 1;
	/*await removeFilter({
                filter: `all`
            });*/
	//         let elemSelect;
	//         elemSelect = $(elem);
	//         let cat = elemSelect.attr("data-cat");
	//         console.log(cat);
	//         elemSelect.parents(".sidebar__inner").find("a").removeClass("active");
	//         elemSelect.addClass("active")
	//         window.filters['Kategoriya'] = {}
	//         window.filters['Kategoriya'][""+cat] = 1;
	//         // await filter(`Kategoriya=${cat}`);
	//         $(".catalog-products .products .list").html("");
	//         var elems = $(".catalog-products .products .list");
	//         onlyLoadProducts(elems, `Kategoriya=${cat}`, "sidebar");
	//     })();
	// });
	$("body")
		.off("click", ".catalog .meta a")
		.on("click", ".catalog .meta a", (e) => {
			if (
				!(
					$(e.target).is(".catalog .meta a") ||
					e.target.closest(".catalog .meta a")
				)
			) {
				return;
			}
			e.preventDefault();
			const elems = $(e.target).is(".catalog .meta a")
				? e.target
				: e.target.closest(".catalog .meta a");
			if (elems.className.indexOf("removeFilter") > -1) {
				(async (elems) => {
					let { data: filters } = await getFilter();
					pageNow = 1;
					delete filters.Kategoriya;
					await removeFilter({
						filter: filters,
					});
					$(".category_page .right .catalog .meta a:first-child").addClass(
						"active"
					);
					$("[data-filter]").removeClass("active");
					$(".catalog-products .products .list").html("");
					var elem = $(".catalog-products .products .list");
					// loadProducts(elem, "meta");
				})(elems);
			} else {
				let meta = $(elems).attr("data-filter");
				(async (meta) => {
					pageNow = 1;
					$(".category_page .right .catalog .meta a:first-child").removeClass(
						"active"
					);
					await removeFilter({
						filter: `all`,
					});
					let filterOn = window.filters["Filtrovat_po"];
					if (typeof filterOn != typeof {}) {
						window.filters["Filtrovat_po"] = {};
					}
					if (
						typeof window.filters["Filtrovat_po"]["" + meta] === "undefined"
					) {
						$("[data-filter='" + meta + "']").addClass("active");
						window.filters["Filtrovat_po"]["" + meta] = 1;
					} else {
						$("[data-filter='" + meta + "']").removeClass("active");
						delete window.filters["Filtrovat_po"]["" + meta];
					}
					let goToFilter = [];
					Object.keys(window.filters).forEach((key) => {
						if (Object.keys(window.filters[key]).length > 0) {
							goToFilter[goToFilter.length] =
								key + "=" + Object.keys(window.filters[key]).join(",");
						}
					});
					await filterAndGet(goToFilter.join("&"));
					$(".catalog-products .products .list").html("");
					var elem = $(".catalog-products .products .list");
					// loadProducts(elem, "meta");
				})(meta);
			}
		});
	// jQuery("body>header>.show_header>.second .center,body>header>.show_header>nav>ul>li.search").off("click").on("click", function (e) {
	//     e.preventDefault();
	//     jQuery(".c-modal--search").addClass("is-active")
	//     setTimeout(function () {
	//         jQuery(".c-search__input-wrapper").addClass("is-shown");
	//         setTimeout(function() {
	//             jQuery(".c-search__input-wrapper").find(":input").focus();
	//             jQuery(".c-search__input-wrapper").find(":input").click();
	//             jQuery(".c-search__input-wrapper").find(":input").trigger('touchstart');
	//         }, 200);
	//         setTimeout(function () {
	//             jQuery(".js-modal-close").addClass("is-shown");
	//         }, 400)
	//     }, 400)
	//     return false;
	// })
	$(
		"body>header>.show_header>.second>.mobile, body>header>.show_header>nav .c-burger__content"
	)
		.off("touchstart")
		.on("touchstart", (e) => {
			$(".cart.mobile+.mini-cart").removeClass("active");
			toggleMobileMenu();
			return false;
		});
	$(".cart.mobile")
		.off("touchstart")
		.on("touchstart", (e) => {
			if (!e.target.closest(".cart.mobile")) {
				return;
			}
			$("body>header>.show_header>nav").removeClass("active");
			e.preventDefault();
			closeMobileMenu();
			$(e.target.closest(".cart.mobile"))
				.next(".mini-cart")
				.toggleClass("active");
		});
	activatedAttrsBtn();
	$("body")
		.off("click", ".attrs .btn")
		.on("click", ".attrs .btn", (e) => {
			if (!e.target.closest(".attrs .btn")) {
				return;
			}
			e.preventDefault();
			var parentElem = $(e.target).is(".attrs .btn")
				? $(e.target)
				: $(e.target).parents(".attrs .btn");
			parentElem.parents(".attrs").find(".btn").removeClass("active");
			parentElem.addClass("active");
			const costPrice = parentElem.attr("data-price");
			const attr = parentElem.attr("data-attr");
			parentElem
				.parents(".product-item")
				.find(".info span.btn")
				.attr("product-attr", attr);

			if (costPrice && attr) {
				parentElem
					.parents(".product-item")
					.find(".info .price b")
					.html(costPrice);
				$(
					".product-view>*>.left .container .info .prices .price b, .product-view>.left .container .info .prices .price b"
				).html(costPrice);
				// parentElem.parents(".product-item").find(".info .prices .rub b").html((parseFloat(`${costPrice}`)/window.rubData).toFixed(0))
				$(
					".product-view>*>.left .container .info .add-to-cart .button, .product-view>.left .container .info .add-to-cart .button"
				).attr("product-attr", attr);
				$(
					".product-view>*>.left .container .info .prices .price b, .product-view>.left .container .info .prices .price b"
				).html(costPrice);
				// $(".product-view>*>.left .container .info .prices .rub b, .product-view>.left .container .info .prices .rub b").html((parseFloat(`${costPrice}`)/window.rubData).toFixed(0))
			}

			const weight2 = parentElem.html();
			weight2 &&
				$(
					".product-view>*>.left .container .info .weight, .product-view>.left .container .info .weight"
				).html(weight2);
		});
	let leaveTimer = false;
	$("nav .cart,.cart+.mini-cart")
		.off("mouseenter")
		.on("mouseenter", (e) => {
			console.log(`enter on`, e.target);
			if (
				!e.target.closest("nav .cart") &&
				!e.target.closest("nav .cart+.mini-cart")
			) {
				return;
			}
			if (leaveTimer) {
				clearTimeout(leaveTimer);
			}
			e.preventDefault();
			$(e.target.closest("nav")).find(".cart+.mini-cart").addClass("active");
		});
	$("nav .cart,.cart+.mini-cart")
		.off("mouseleave")
		.on("mouseleave", (e) => {
			console.log(`leave on`, e.target);
			if (
				!e.target.closest("nav .cart") &&
				!e.target.closest("nav .cart+.mini-cart")
			) {
				return;
			}
			e.preventDefault();
			leaveTimer = setTimeout(
				(e) => {
					$(e.target.closest("nav"))
						.find(".cart+.mini-cart")
						.removeClass("active");
				},
				300,
				e
			);
		});
	let tabs = $(".tabs .body .tab");
	for (let i = 0; i < tabs.length; i++) {
		tabs[i].setAttribute("height", tabs[i].scrollHeight);
	}
	$(".tabs .head span")
		.off("click")
		.on("click", (e) => {
			$(e.target).parent().children().removeClass("active");
			$(e.target).addClass("active");
			var id = $(e.target).attr("data-tab");
			$(".tabs .body .tab").css("height", "0px");
			var elem = $(".tabs .body .tab[data-id='" + id + "']");
			console.log(".tabs .body .tab[data-id='" + id + "']");
			elem.css("height", elem.attr("height") + "px");
			elem.parent().css("height", elem.attr("height") + "px");
			elem.parent().children().removeClass("active");
			elem.addClass("active");
		});
	let tabActiveId = $(".tabs .head span.active").attr("data-tab");
	let tabActive = $(".tabs .body .tab[data-id='" + tabActiveId + "']");
	tabActive.parent().css("height", tabActive.attr("height") + "px");
	tabActive.css("height", tabActive.attr("height") + "px");
	tabActive.addClass("active");

	const timeOffset = new Date().getTimezoneOffset();
	if (typeof workTime !== "undefined" && typeof workTime !== typeof []) {
		workTime = workTime.split("-").map(function (e) {
			const humanDate = e.split(":");
			const date = new Date();
			date.setHours(humanDate[0], humanDate[1], 0, 0);
			return date;
		});
	} else {
		window.workTime = [];
	}
	preloaderActive = false;
	bx();
	$(".bx-slider").bxSlider({
		useCSS: false,
		controls: false,
		pager: false,
		auto: true,
		speed: 500,
		mode: "fade",
		easing: "ease-in-out",
	});
	new Swiper(".slider.swiper-container", {
		loop: true,
		effect: "fade",
		speed: 800,
		autoplay: {
			delay: 5000,
		},
		fadeEffect: {
			crossFade: true,
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
	});
	new Swiper(".swiper-container.widget-sidebar", {
		slidesPerView: 1,
		loop: true,
		speed: 800,
		autoplay: {
			delay: 5000,
		},
		fadeEffect: {
			crossFade: true,
		},
	});
	let perView =
			$("footer .action .swiper-container .swiper-slide").length > 3
				? 4
				: $("footer .action .swiper-container .swiper-slide").length,
		perViewInExists = 4,
		loopFooter = false,
		regularProductOption = {
			slidesPerView: 4,
			loop: true,
			speed: 800,
			autoplay: {
				delay: 5000,
			},
			fadeEffect: {
				crossFade: true,
			},
			navigation: {
				nextEl: ".regular-production .swiper-button-next",
				prevEl: ".regular-production .swiper-button-prev",
			},
		},
		isMobile = false;
	if (window.innerWidth <= 900) {
		isMobile = true;
		perView = 1;
		perViewInExists = 3;
		loopFooter = true;
		$(
			".category_page .categories a, .catalog-products.index .category a"
		).show();
		//$(".category_page .categories a.active").addClass("showSubMenu");
		delete regularProductOption.autoplay;
		regularProductOption.slidesPerView = 1;
	} else {
		$(".category_page .categories a").show();
	}
	findPositionProducts();
	if (window.innerWidth <= 900) {
		$("body")
			.off(
				"click",
				".category_page .categories a.active, .catalog-products.index .category a.active"
			)
			.on(
				"click",
				".category_page .categories a.active, .catalog-products.index .category a.active",
				(e) => {
					console.log("cat");
					e.preventDefault();
					if (typeof $(".category_page .categories a")[0] !== "undefined") {
						// $(".category_page .categories a:not(.active)").toggle()
						let active = $(".category_page .categories a.active")[0];
						$(".category_page .categories a.active").remove();
						$(".category_page .categories").prepend(active);
						$(".category_page .categories a.active").toggleClass("showSubMenu");
					} else {
						// $(".catalog-products.index .category a:not(.active)").toggle()
						let active = $(".catalog-products.index .category a.active")[0];
						$(".catalog-products.index .category a.active").remove();
						$(".catalog-products.index .category").prepend(active);
						$(".catalog-products.index .category a.active").toggleClass(
							"showSubMenu"
						);
					}
					return false;
				}
			);
	}
	new Swiper(".swiper-container.products", regularProductOption);
	new Swiper("footer .action .swiper-container", {
		slidesPerView: perView,
		speed: 800,
		loop: loopFooter,
		simulateTouch: isMobile,
		shortSwipes: isMobile,
		longSwipes: isMobile,
		allowTouchMove: isMobile,
		fadeEffect: {
			crossFade: true,
		},
	});
	if (
		typeof $(".category_page .right .catalog .meta")[0] !== "undefined" &&
		!isMobile
	) {
		let mouseSwipe = false,
			mouseSwipeScroll = false;
		$(".category_page .right .catalog .meta .container").on("mousedown", () => {
			mouseSwipe = true;
		});
		let metaPosition = $(".category_page .right .catalog .meta").offset().left;
		let widthPosition = $(".category_page .right .catalog .meta").outerWidth();
		let childrens =
			$(".category_page .right .catalog .meta .container").children().length -
			1;
		let coefficient = childrens - 1;
		let offsetMaxPosition = -(widthPosition / childrens);
		let offsetMaxPositionScroll = widthPosition / childrens;
		let widthContainer = $(".category_page .right .catalog .meta .container")[0]
			.scrollWidth;
		let widthParent = $(".category_page .right .catalog .meta").width();
		let arrSwipe = [];
		for (
			let i = parseInt(widthContainer) - 5;
			i < parseInt(widthContainer) + 5;
			i++
		) {
			arrSwipe[arrSwipe.length] = i > parseInt(widthParent) - 5;
		}
		for (
			let i = parseInt(widthParent) - 5;
			i < parseInt(widthParent) + 5;
			i++
		) {
			arrSwipe[arrSwipe.length] = parseInt(widthContainer) - 5 > i;
		}
		arrSwipe = arrSwipe.filter((item) => item != true);
		if (arrSwipe.length == 0) {
			$(".category_page .right .catalog .meta .scrollbar")
				.show()
				.css("width", `${widthParent - (widthContainer - widthParent)}px`);
			$(".category_page .right .catalog .meta .container").on(
				"mousemove",
				(e) => {
					e.preventDefault();
					if (!mouseSwipe) {
						console.log("not start");
						return;
					}
					let pos =
						e.originalEvent.clientX - metaPosition - metaPosition / coefficient;
					if (pos > 0) {
						pos = 0;
					} else if (pos < offsetMaxPosition) {
						pos = offsetMaxPosition;
					}
					$(".category_page .right .catalog .meta .container").css(
						"transform",
						`translateX(${pos}px)`
					);
					$(".category_page .right .catalog .meta .scrollbar").css(
						"transform",
						`translateX(${-pos}px)`
					);
					//metaPosition - e.originalEvent.clientX
				}
			);
			$(".category_page .right .catalog .meta .container").on("drag", (e) => {
				e.preventDefault();
			});
			$(".category_page .right .catalog .meta .container").on(
				"mouseup mouseleave",
				() => {
					mouseSwipe = false;
				}
			);
			$(".category_page .right .catalog .meta .scrollbar").on(
				"mousedown",
				() => {
					mouseSwipeScroll = true;
				}
			);
			$("body").on("mousemove", (e) => {
				e.preventDefault();
				if (!mouseSwipeScroll) {
					console.log("not start");
					return;
				}
				let pos =
					e.originalEvent.clientX - metaPosition - metaPosition / coefficient;
				console.warn(pos);
				if (pos < 0) {
					pos = 0;
				} else if (pos > offsetMaxPositionScroll) {
					pos = offsetMaxPositionScroll;
				}
				$(".category_page .right .catalog .meta .container").css(
					"transform",
					`translateX(${-pos}px)`
				);
				$(".category_page .right .catalog .meta .scrollbar").css(
					"transform",
					`translateX(${pos}px)`
				);
				//metaPosition - e.originalEvent.clientX
			});
			$(".category_page .right .catalog .meta .scrollbar").on("drag", (e) => {
				e.preventDefault();
			});
			$("body").on("mouseup", () => {
				mouseSwipeScroll = false;
			});
		} else {
			$(".category_page .right .catalog .meta .scrollbar").hide();
		}
	}
	window.inExists = new Swiper(".swiper-container.in_exists", {
		slidesPerView: perViewInExists,
		speed: 800,
		autoplay: {
			delay: 5000,
		},
		fadeEffect: {
			crossFade: true,
		},
	});
	if ($(".product-view>.left .container .info .in_exists .body").length > 0) {
		$(".product-view>.left .container .info .in_exists .body").addClass(
			"show_page"
		);
	}
	$(".swiper-container.in_exists")
		.off("mouseenter mouseleave")
		.on("mouseenter mouseleave", () => {
			window.inExists.autoplay.paused
				? window.inExists.autoplay.stop()
				: window.inExists.autoplay.start();
		});

	console.log("test");
	var tomorrow = new Date();
	window.isSetDate = false;
	window.isSetTime = false;
	var formatDate = "yyyy-mm-d";

	if (typeof workTime[0] !== "undefined") {
		const secondsNow = parseInt(SystemTime);
		const correctTime = timeOffset + 60;
		const timeNow = new Date((secondsNow + correctTime) * 1000);
		let test = workTime[1].getHours() - (timeNow.getHours() + 1);
		window.test = test;

		let disableTime = [];
		/*disableTime = [[3, 0], [16, 0], [7, 0]];
        for (let i = workTime[0].getHours(), fromDate = new Date().getHours(); i < fromDate; i++) {
            for (let z = 0; z < (60 / intervalSend); z++) {
                disableTime[disableTime.length] = [i, z * 30];
            }
        }*/
		$(".timepicker").pickadate({
			// Strings and translations
			monthsFull: [
				"Январь",
				"февраль",
				"март",
				"апрель",
				"май",
				"июнь",
				"июль",
				"август",
				"сентябрь",
				"октябрь",
				"ноябрь",
				"декабрь",
			],
			monthsShort: [
				"Янв",
				"Фев",
				"Мар",
				"Апр",
				"Май",
				"Июн",
				"Июл",
				"Авг",
				"Сен",
				"Окт",
				"Ноя",
				"Дек",
			],
			weekdaysFull: [
				"Воскресенье",
				"понедельник",
				"вторник",
				"среда",
				"четверг",
				"пятница",
				"суббота",
			],
			weekdaysShort: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
			showMonthsShort: undefined,
			showWeekdaysFull: undefined,
			format: formatDate,

			// Buttons
			today: "Сегодня",
			clear: false,
			close: "Закрыть",
			firstDay: 1,
			container: $("body"),

			// Accessibility labels
			labelMonthNext: "Следующий месяц",
			labelMonthPrev: "Предыдущий месяц",
			labelMonthSelect: "Выбрать месяц",
			labelYearSelect: "Выбрать год",
			min: workTime[0],
			max: new Date(tomorrow.setDate(tomorrow.getDate() + 1)),
			onSet: function (ev) {
				console.log(ev);
				if (ev.select) {
					window.isSetDate = true;
					const val = $(".timepicker").val();
					const date = new Date(val);
					const selected = date.getDate() + "" + date.getMonth();
					const now = new Date().getDate() + "" + new Date().getMonth();
					$("[data-add-to-cart]").attr("timepicker", date.getTime());
					if (selected != now) {
						$(".timepickers2").trigger("click");
					} else {
						$(".timepickers").trigger("click");
					}

					var event = new Event("checkDataDate");
					event.doIng = val;
					event.doType = "set";
					document.body.dispatchEvent(event);
				}
			},
			onClose: function () {
				if (!window.isSetDate) {
					$(".timepicker").val("");
					$(".timepickers").val("");
					$("[data-add-to-cart]").removeAttr("timepicker");
					$("[data-add-to-cart]").removeAttr("timepickers");

					var event = new Event("checkDateFaild");
					event.doIng = "";
					event.doType = "close";
					document.body.dispatchEvent(event);
				}
			},
		});
		let configTime = {
			closeOnSelect: true,
			closeOnClear: false,
			formatLabel: "HH:i",
			min: [workTime[0].getHours(), workTime[0].getMinutes()],
			max: [workTime[1].getHours(), workTime[1].getMinutes()],
			clear: false,
			formatSubmit: "HH:i",
			disable: disableTime,
			container: $("body"),
			onSet: function (ev) {
				console.log(ev);
				if (ev.select) {
					window.isSetTime = true;
					const val = $(".timepickers").val();
					const date = new Date(val);
					$("[data-add-to-cart]").attr("timepickers", date.getTime());
					console.log(val);
					var event = new Event("checkTimeDate");
					event.doIng = val;
					event.doType = "set";
					document.body.dispatchEvent(event);
				}
			},
			onClose: function () {
				if (!window.isSetTime) {
					$(".timepicker").val("");
					$(".timepickers").val("");
					$("[data-add-to-cart]").removeAttr("timepicker");
					$("[data-add-to-cart]").removeAttr("timepickers");

					var event = new Event("checkDateFaild");
					event.doIng = "";
					event.doType = "close";
					document.body.dispatchEvent(event);
				}
			},
		};
		$(".timepickers").pickatime(configTime);
		let configTime2 = {
			...configTime,
		};
		delete configTime2.disable;
		$(".timepickers2").pickatime(configTime2);
	}

	$("body")
		.off(
			"click",
			".cart+.mini-cart .elem .remove, .product-view>.conain>.left.order .elem .remove"
		)
		.on(
			"click",
			".cart+.mini-cart .elem .remove, .product-view>.conain>.left.order .elem .remove",
			function () {
				$(this)
					.parents("[data-product-parent]")
					.hide(300, () => {
						(async (th) => {
							const id = $(th)
								.parents("[data-product-parent]")
								.find("[product-id]")
								.attr("product-id");
							const cart_id = $(th)
								.parents("[data-product-parent]")
								.attr("data-cart-id");
							$(th).parents("[data-product-parent]").remove();
							orderPage();
							const counter = await removeCart({
								id,
								all: true,
								cart_id: cart_id,
							});
							animChange(counter.cart);
							/*if(productsLength<=0) {
                  $(".product-view>.conain>.left.order .step[data-step]").removeClass('active');
                }*/
						})(this);
					});
			}
		);
	if (typeof $(".regular-production .body .product-item")[0] !== "undefined") {
		var maxHeight = 0;
		$(".regular-production .body .product-item").each(function (i, elem) {
			if ($(elem).outerHeight() > maxHeight) {
				maxHeight = $(elem).outerHeight();
			}
		});
		$(".regular-production .body .product-item").css(
			"height",
			maxHeight + "px"
		);
	}
	var menu = $(".show_header nav").offset().top;
	const adminOffset = $("html").css("paddingTop");
	heightNav = $(".hide_header").outerHeight() + parseFloat(adminOffset);
	const catOnMobileHover = $(
		".category_page .right .catalog .category:not(.onMobileHover), .catalog-products.index .products .list, .page .actions"
	).offset();
	let topCat =
		typeof catOnMobileHover !== "undefined" &&
		typeof catOnMobileHover.top !== "undefined"
			? catOnMobileHover.top
			: 0;
	const menuFN = () => {
		const topNow = $(window).scrollTop();
		if (topCat) {
			const arrTopProduct = Object.keys(window.scrollTopProduct);
			for (let i = 0; i < arrTopProduct.length; i++) {
				if (
					(arrTopProduct[i] <= topNow && arrTopProduct[i + 1] >= topNow) ||
					(arrTopProduct.length - 1 == i && arrTopProduct[i] <= topNow)
				) {
					$(window.scrollTopProduct[arrTopProduct[i]]).addClass("activeScroll");
				} else {
					$(window.scrollTopProduct[arrTopProduct[i]]).removeClass(
						"activeScroll"
					);
				}
			}
		}
		if (topNow >= topCat) {
			$(
				".category_page .right .catalog .category.onMobileHover, .catalog-products .onMobileHover"
			).addClass("active");
		} else {
			$(
				".category_page .right .catalog .category.onMobileHover, .catalog-products .onMobileHover"
			).removeClass("active");
		}
		if (topNow > menu + 50) {
			$(".hide_header").addClass("show");
			if ($(".show_header .cart+.mini-cart").hasClass("active")) {
				$(".show_header .cart+.mini-cart")
					.addClass("fast")
					.removeClass("active")
					.delay(100)
					.queue(() => {
						$(".show_header .cart+.mini-cart")
							.removeClass("fast")
							.dequeue()
							.delay(100)
							.queue(() => {
								$(".hide_header .cart+.mini-cart")
									.addClass("fast active")
									.dequeue()
									.delay(100)
									.queue(() => {
										$(".hide_header .cart+.mini-cart")
											.removeClass("fast")
											.dequeue();
									});
							});
					});
			}
		} else {
			$(".hide_header").removeClass("show");
			if ($(".hide_header .cart+.mini-cart").hasClass("active")) {
				$(".hide_header .cart+.mini-cart")
					.addClass("fast")
					.removeClass("active")
					.delay(100)
					.queue(() => {
						$(".hide_header .cart+.mini-cart")
							.removeClass("fast")
							.dequeue()
							.delay(100)
							.queue(() => {
								$(".show_header .cart+.mini-cart")
									.addClass("fast active")
									.dequeue()
									.delay(100)
									.queue(() => {
										$(".show_header .cart+.mini-cart")
											.removeClass("fast")
											.dequeue();
									});
							});
					});
			}
		}
	};
	/*menuFN();
    $(window).off("scroll").on("scroll", menuFN);*/
	window.doLoadMax = 16;
	if ($(window).width() <= 900) {
		window.doLoadMax = 12;
	}
	var elem = $(".catalog-products .products:not(.cats) .list");
	if (typeof elem[0] !== "undefined") {
		// const result = await filterAndGet(`Kategoriya=4`, { page: 1 });
		console.warn("TESTERRR");
		$(".catalog .category a[data-cat='1']").addClass("active");
		$(".catalog-products .menu .sidebar__inner a").removeClass("active");
		$(".catalog-products .menu .sidebar__inner a[data-cat='4']").addClass(
			"active"
		);
		window.filters["Kategoriya"] = { 4: 4 };
		loadProducts(elem, "categ", `Kategoriya=4`, { page: 1 });
	} else {
		var elem = $(".catalog-products .products.cats .list");
		if (typeof elem[0] !== "undefined") {
			window.doLoadMax = 16;
			if ($(window).width() <= 900) {
				window.doLoadMax = 16;
			}
		}
	}
	const order = $(".product-view>.conain>.left.order .products");
	if (typeof order[0] !== "undefined") {
		(async (order) => {
			function getCart() {
				return new Promise(function (resolve, reject) {
					var attrs = {};
					attrs["type"] = "cartList";
					try {
						fetch(default_link + main_page_lang + "ajaxLoad", {
							method: "POST",
							headers: {
								"Content-Type": "application/json",
							},
							body: JSON.stringify(attrs),
						})
							.then(function (resp) {
								return resp.json();
							})
							.then(function (data) {
								triggerEvent("cartList", data);
								resolve(data);
							})
							.catch(function (e) {
								reject(e);
								triggerEvent("cartErrorList", e);
							});
					} catch (e) {
						reject(e);
						triggerEvent("cartErrorList", e);
					}
				});
			}
			const { data: products } = await getCart();
			if (products.length > 0) {
				$(".product-view>.conain>.left.order .step[products-step]").removeClass(
					"active"
				);
			}
			const { allCost } = renderAjax(products, order);
			$(
				".product-view.order>.conain>.right .total .head .total_cart b.uah"
			).html((allCost / window.rubData).toFixed(0));
			$(
				".product-view.order>.conain>.right .total .head .total_cart b.rub"
			).html(allCost);
			for (let i = 0; i < products.length; i++) {
				if (products[i].Kategoriya == "21") {
					$(".work-modal.general").css("display", "none");
					//$(".work-modal.breakfast").css("display", "flex");
					break;
				} else {
					$(".work-modal.general").css("display", "flex");
					//$(".work-modal.breakfast").css("display", "none");
				}
			}
			shopReinit();
			orderPage();
		})(order);
	}
	document.body.addEventListener("productChangeCount", (e) => {
		(async () => {
			console.log("e.detail", e.detail);
			const { cart: cartNow } = await editCart(e.detail);
			let { allCost, allDiscount, products } = renderAjax(
				cartNow,
				$(".cart+.mini-cart .contain"),
				true
			);
			for (let i = 0; i < products.length; i++) {
				// $(".mini-cart [product-id='" + products[i].sId + "']").parents("[data-product-parent][data-cart-id="+products[i].cart_id+"]").find("b.uah").html(products[i]['Cena-rub']);
				// $(".mini-cart [product-id='" + products[i].sId + "']").parents("[data-product-parent][data-cart-id="+products[i].cart_id+"]").find(".price .rub").html(products[i].Cena);
				$(".mini-cart [product-id='" + products[i].sId + "']")
					.parents(
						"[data-product-parent][data-cart-id=" + products[i].cart_id + "]"
					)
					.find(".price b")
					.html(products[i].Cena);
				$(".mini-cart [product-id='" + products[i].sId + "']")
					.parents(
						"[data-product-parent][data-cart-id=" + products[i].cart_id + "]"
					)
					.find('input[data-changer="input"]')
					.val(products[i].cart.count);
				$(".mini-cart [product-id='" + products[i].sId + "']")
					.parents(
						"[data-product-parent][data-cart-id=" + products[i].cart_id + "]"
					)
					.attr("data-count", products[i].cart.count);
				//console.warn('products[i].Cena', products[i].Cena)
				$(".product-view.order [product-id='" + products[i].sId + "']")
					.parents(
						"[data-product-parent][data-cart-id=" + products[i].cart_id + "]"
					)
					.find(".price b")
					.html(products[i].Cena);
				// $(".product-view.order [product-id='" + products[i].sId + "']").parents("[data-product-parent][data-cart-id="+products[i].cart_id+"]").find("b.uah").html(products[i]['Cena-rub']);
				// console.warn($(".product-view.order [product-id='" + products[i].sId + "']").parents("[data-product-parent][data-cart-id="+products[i].cart_id+"]").find(".price .rub"), products[i]['Cena-rub'])
				// $(".product-view.order [product-id='" + products[i].sId + "']").parents("[data-product-parent][data-cart-id="+products[i].cart_id+"]").find(".price .rub").html(products[i].Cena);
				$(".product-view.order [product-id='" + products[i].sId + "']")
					.parents(
						"[data-product-parent][data-cart-id=" + products[i].cart_id + "]"
					)
					.attr("data-selfdeilerysale", products[i].shippingSale);
				$(".product-view.order [product-id='" + products[i].sId + "']")
					.parents(
						"[data-product-parent][data-cart-id=" + products[i].cart_id + "]"
					)
					.find('input[data-changer="input"]')
					.val(products[i].cart.count);
				$(".product-view.order [product-id='" + products[i].sId + "']")
					.parents(
						"[data-product-parent][data-cart-id=" + products[i].cart_id + "]"
					)
					.attr("data-count", products[i].cart.count);
			}
			// $(".cart+.mini-cart .bottom .price .cost b.uah, .product-view.order .right .total .head .total_cart b.uah").html((allCost/window.rubData).toFixed(0));
			// $(".cart+.mini-cart .bottom .price .cost b.rub, .product-view.order .right .total .head .total_cart b.rub").html(allCost);
			$(
				".cart+.mini-cart .bottom .price .cost b, .product-view.order .right .total .head .total_cart b"
			).html(allCost);
			window.totalOrderPrice = allCost;
		})();
	});
	$(".category_page .right .catalog .category.onMobileHover")
		.off("scroll")
		.on("click", () => {
			$("body,html").animate(
				{
					scrollTop: topCat - 80,
				},
				300
			);
		});
	const cats = $(".category_page .left .categories");
	//    if(typeof(cats[0])!=="undefined") {
	//        //catShowActive(cats);
	//        cats.find("a").click((e) => {
	//            loadedParam.altname = $(e.target.closest(`a[data-alt-name]`)).attr("data-alt-name")
	//            const cats = $(".category_page .left .categories");
	//            console.log(e.target)
	//            //catShowActive(cats);
	//            window.history.pushState({}, "", $(e.target.closest(`a[data-alt-name]`)).attr("href"));
	//            return false;
	//        })
	//    }

	//    if(typeof($('.product-view.order')[0])!=="undefined") {
	//        const adminOffset = $("html").css("paddingTop");
	//        const heightNav = $(".hide_header").outerHeight() + (parseFloat(adminOffset));
	//        new StickySidebar('.product-view.order>.conain>.right', {
	//            topSpacing: heightNav,
	//            containerSelector: '.product-view.order'
	//        });
	//    }
	$("body").on("click", function (e) {
		/*if(actionWithElement(e.target, ".catalog-products .menu .sidebar__inner a")) {
            e.preventDefault();
        }*/
		if (
			$(window).width() > 900 &&
			!actionWithElement(e.target, ".cart") &&
			!actionWithElement(e.target, ".mini-cart") &&
			$(".cart+.mini-cart").hasClass("active")
		) {
			$(".cart+.mini-cart").removeClass("active");
		}
	});
	var currentStepActive = 1;
	$(".order>.conain>.left>.step :input").on("focus change", function () {
		if (currentStepActive <= $(this).parents(".step").data("step")) {
			$(
				".product-view>*>.left.order .block.mobile .step[data-step=" +
					$(this).parents(".step").data("step") +
					"]"
			).addClass("active");
			currentStepActive = $(this).parents(".step").data("step");
		}
	});
	$(".product-view.order button")
		.off("click")
		.on("click", (e) => {
			console.log("CLICK SUBMIT");
			if (!window.orderSubmitted) {
				var errors = false;
				if (
					$(".cusname").val().length == 0 ||
					$(".phoneInput").val().length == 0
				) {
					errors = true;
				}
				if (
					$("#time_send_now").prop("checked") &&
					!$("#private_house").prop("checked") &&
					($(".street").val().length == 0 ||
						$(".house").val().length == 0 ||
						$(".entrance").val().length == 0 ||
						$(".area-block .area").val().length == 0)
				) {
					errors = true;
				}
				if (
					$("#time_send_after").prop("checked") &&
					!$("#private_house").prop("checked") &&
					($(".street").val().length == 0 ||
						$(".house").val().length == 0 ||
						$(".entrance").val().length == 0 ||
						$(".area-block .area").val().length == 0)
				) {
					errors = true;
				}
				if (
					$("#private_house").prop("checked") &&
					($(".street").val().length == 0 ||
						$(".house").val().length == 0 ||
						$(".area-block .area").val().length == 0)
				) {
					errors = true;
				}
				if (
					$("#vip_deliv").prop("checked") &&
					($(".street").val().length == 0 ||
						$(".house").val().length == 0 ||
						$(".entrance").val().length == 0 ||
						$(".apartament").val().length == 0 ||
						$(".area-block .area").val().length == 0)
				) {
					errors = true;
				}
				if (jQuery("[name='typePay']:checked").length == 0) {
					errors = true;
				}
				if (errors) {
					_alert({
						title: "Ошибка",
						typeMess: "error",
						desc: "Проверьте правильность заполнения полей!",
					});
					return;
				}
			}
			e.preventDefault();
			const typePay = $(
				".product-view>*>.left.order .step[data-step][data-step='3'] [name='typePay']:checked"
			).val();
			let postArr = $("form.order").serializeArray();
			let sendArr = {};
			$("body").addClass("productsloading");
			for (let i = 0; i < postArr.length; i++) {
				sendArr[postArr[i].name] = postArr[i].value;
			}
			(async (sendArr) => {
				let resp = await addOrder(sendArr);
				console.log("resp", resp);
				$("body").removeClass("productsloading");
				if (resp.success) {
					_alert({
						title: "Заказ",
						desc:
							"Успешно, оператор свяжется с Вами!" +
							(typeof resp.location !== "undefined"
								? "\nПереход на страницу оплаты "
								: ""),
						onclose: () => {
							if (resp.location) {
								jQuery(".paymentform").html(resp.form);
							} else {
								window.location.href = default_link;
							}
						},
					});
					// $.ajax({
					//     url: default_link+"sendTelegram",
					//     type: 'POST',
					//     timeout: 100,
					//     data: {order_id: resp.order_id},
					//     success: function() {
					//     }
					// });
				} else {
					_alert({
						title: "Ошибка",
						typeMess: "error",
						desc: "Произошла ошибка, попробуйте заного сделать заказ!",
						onclose: () => {
							window.location.href = default_link;
						},
					});
				}
				// animChange()
				$("form :input").val("").prop("checked", false).removeAttr("checked");
				$(".product-view.order>.conain>.left.order .products").html(
					$(".product-ajax-not-exists").html()
				);
				$(
					".product-view.order>.conain>.right .step[data-step='1']"
				).removeClass("active");
				$(
					".product-view.order>.conain>.right .step[data-step='2']"
				).removeClass("active");
				$(
					".product-view.order>.conain>.right .step[data-step='3']"
				).removeClass("active");
				$(".product-view>.conain>.left.order .step[data-step='1']").removeClass(
					"active"
				);
				$(".product-view>.conain>.left.order .step[data-step='2']").removeClass(
					"active"
				);
				$(".product-view>.conain>.left.order .step[data-step='3']").removeClass(
					"active"
				);
				$(".product-view.order>.conain>.right .total .checkbox input").attr(
					"disabled",
					"disabled"
				);
				$(".product-view.order>.conain>.right .submit button").attr(
					"disabled",
					"disabled"
				);
			})(sendArr);
		});
	$("body")
		.off("click", ".c-search__card")
		.on("click", ".c-search__card", (e) => {
			e.preventDefault();
			const altname = e.target
				.closest("[data-altname]")
				.getAttribute("data-altname");
			$(".search-box .c-modal--search .c-modal__close span").trigger("click");
			console.warn("altname", e.target, e.target.closest("[data-altname]"));
			setTimeout(
				(altname) => {
					const link = product_link_route.replace("testtesttesttest", altname);
					window.location.href = link;
				},
				300,
				altname
			);
		});
};
new Swiper(".swiper-category", {
	loop: false,
	speed: 800,
	autoplay: false,
	freeMode: true,
	slidesPerView: "auto",
	mousewheel: true,
	speed: 700,
	scrollbar: {
		el: ".swiper-scrollbar",
		hide: true,
	},
	on: {
		init: () => {
			if ($(".swiper-category .swiper-wrapper .swiper-slide").length == 0) {
				$(".swiper-category").addClass("swiper-empty-list");
			}
		},
	},
});
function actionWithElement(target, data) {
	if (jQuery(target).is(data) || jQuery(target).parents(data).length) {
		return true;
	}
	return false;
}

jQuery(document).on("resizeWindow", () => {
	readyDoc();
});

("use strict");

function _instanceof(left, right) {
	if (
		right != null &&
		typeof Symbol !== "undefined" &&
		right[Symbol.hasInstance]
	) {
		return right[Symbol.hasInstance](left);
	} else {
		return left instanceof right;
	}
}

function _classCallCheck(instance, Constructor) {
	if (!_instanceof(instance, Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _defineProperties(target, props) {
	for (var i = 0; i < props.length; i++) {
		var descriptor = props[i];
		descriptor.enumerable = descriptor.enumerable || false;
		descriptor.configurable = true;
		if ("value" in descriptor) descriptor.writable = true;
		Object.defineProperty(target, descriptor.key, descriptor);
	}
}

function _createClass(Constructor, protoProps, staticProps) {
	if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	if (staticProps) _defineProperties(Constructor, staticProps);
	return Constructor;
}

function _defineProperty(obj, key, value) {
	if (key in obj) {
		Object.defineProperty(obj, key, {
			value: value,
			enumerable: true,
			configurable: true,
			writable: true,
		});
	} else {
		obj[key] = value;
	}
	return obj;
}

function empty(e) {
	switch (e) {
		case "":
		case 0:
		case "0":
		case null:
		case false:
		case undefined:
		case typeof e === "undefined":
			return true;

		default:
			return false;
	}
}

var appeared = new Event("appeared");
var disappeared = new Event("disappeared");

var AppearObserver =
	/*#__PURE__*/
	(function () {
		function AppearObserver(settings) {
			var _this = this;

			_classCallCheck(this, AppearObserver);

			_defineProperty(this, "observer", void 0);

			_defineProperty(this, "defaults", {
				root: document.viewport,
				deferred: false,
				observer: {
					start: 0,
					step: 0.05,
					finish: 1,
				},
			});

			_defineProperty(this, "options", {});

			_defineProperty(this, "observables", []);

			this.options = Object.assign(this.defaults, settings);
			var threshold = this.generateThresholds();
			this.observer = new IntersectionObserver(
				function (entries) {
					for (var i = 0, l = entries.length; i < l; i++) {
						var entry = entries[i];

						if (entry.isIntersecting) {
							if (
								entry.intersectionRatio >=
								entry.target.observeOptions.heightPerc *
									entry.target.observeOptions.threshold
							) {
								if (!entry.target.observeOptions.isAppeared) {
									_this.appear(entry.target);
								}
							}
						} else if (entry.target.observeOptions.isAppeared) {
							_this.disappear(entry.target);
						}
					}
				},
				{
					root: this.options.root,
					threshold: threshold,
				}
			);
			window.addEventListener("resizeend", function () {
				if (_this.observables.length > 0) {
					for (var i = 0, s = _this.observables.length; i < s; i++) {
						_this.observables[i].observeOptions.heightPerc =
							Math.min(window.innerHeight, _this.observables[i].offsetHeight) /
							Math.max(window.innerHeight, _this.observables[i].offsetHeight);
					}
				}
			});
		}

		_createClass(AppearObserver, [
			{
				key: "generateThresholds",
				value: function generateThresholds() {
					var symbs = this.options.observer.step.toString().indexOf(".")
						? this.options.observer.step.toString().split(".")[1].length
						: 0;
					var threshold = [];

					for (
						var t = this.options.observer.start,
							f = this.options.observer.finish,
							s = this.options.observer.step;
						t < f;
						t += s
					) {
						threshold.push(parseFloat(t.toFixed(symbs)));
					}

					return threshold;
				},
			},
			{
				key: "disconnect",
				value: function disconnect(el) {
					this.observer.unobserve(el);
					this.observables.splice(this.observables.indexOf[el], 1); //el.observeOptions = null
				},
			},
			{
				key: "appear",
				value: function appear(el) {
					el.observeOptions.isAppeared = true;
					el.classList.add("is-appeared");
					el.dispatchEvent(appeared);

					if (el.observeOptions.unobserve === true) {
						this.disconnect(el);
					}
				},
			},
			{
				key: "disappear",
				value: function disappear(el) {
					el.observeOptions.isAppeared = false;
					el.classList.remove("is-appeared");
					el.dispatchEvent(disappeared);

					if (el.observeOptions.unobserve === true) {
						this.disconnect(el);
					}
				},
			},
			{
				key: "show",
				value: function show(el) {
					if (this.observables.includes(el)) {
						this.appear(el);
					}
				}, //РАЗДЕЛ: Функция, подвязывающая элемент к обзерверу
				//ПОМЕТКА: Принимает html элемент или массив элементов или HTML Collection
				//TODO:
			},
			{
				key: "observe",
				value: function observe(entries) {
					var elems = entries; //Можно добавить проверку на селектор

					if (!empty(elems)) {
						if (!empty(elems.length)) {
							elems = Array.from(elems);
						} else {
							elems = [elems];
						}

						for (var i = 0, l = elems.length; i < l; i++) {
							if (getComputedStyle(elems[i]).display !== "none") {
								var options = {};
								options.threshold =
									elems[i].getAttribute("data-threshold") != null
										? parseInt(elems[i].getAttribute("data-threshold")) / 1000
										: 0;
								options.unobserve =
									elems[i].getAttribute("data-unobserve") != null
										? String(elems[i].getAttribute("data-unobserve")) === "true"
										: false;
								options.isAppeared = false;
								options.isDisappeared = false;
								options.heightPerc =
									Math.min(window.innerHeight, elems[i].offsetHeight) /
									Math.max(window.innerHeight, elems[i].offsetHeight);
								elems[i].observeOptions = options;

								if (empty(this.observables[elems[i]])) {
									this.observables.push(elems[i]);
									this.observer.observe(elems[i]);
								}
							}
						}
					} else {
						throw new Error("Элементы не найдены");
					}
				},
			},
		]);

		return AppearObserver;
	})();

var appearObserver = new AppearObserver();

jQuery(document).ready(() => {
	const $products = document.getElementsByClassName("animateMe");
	if ($products.length > 0) {
		console.log("ELEMENT APPEAR", $products);
		appearObserver.observe($products);
		Array.prototype.slice.call($products).forEach((product) => {
			product.addEventListener("appeared", (e) => {
				jQuery(e.target).addClass("activeScale");
				console.log("ELEMENT APPEAR", e.target);
			});
			product.addEventListener("disappeared", (e) => {
				jQuery(e.target).removeClass("activeScale");
			});
		});
	}
	var t = $("#cardinalParams")
		.html()
		.replace(new RegExp("var (.+?) = (.+?);", "g"), '"$1":$2,')
		.trim();
	eval("window.ajaxLoadParam = {" + t.substr(0, t.length - 1) + "}");
	window.menuActive = false;
	window.menuAnimating = false;
	if ($(window).width() <= 900) {
		const anim = new TimelineLite({
			onComplete: function () {
				menuActive = true;
				menuAnimating = false;
			},
			onReverseComplete: function () {
				menuActive = false;
				menuAnimating = false;
			},
		});
		window.anim = anim;
		anim
			.fromTo(
				"body>header>.show_header>nav",
				0.6,
				{
					opacity: 0.1,
					visibility: "hidden",
				},
				{
					opacity: 1,
					visibility: "visible",
				}
			)
			.fromTo(
				"body>header>.show_header>nav",
				0.8,
				{
					clipPath: "circle(0px at 40px 0px)",
				},
				{
					clipPath: "circle(860px at calc(50% - 1px) calc(50% - 1px))",
					ease: Sine.easeInOut,
					force3D: true,
				}
			)
			.staggerFrom(
				document.querySelectorAll("body>header>.show_header>nav>ul>li"),
				1.9,
				{
					opacity: 0,
					y: 35,
					ease: Power2.easeInOut,
					force3D: true,
				},
				0.2
			)
			.paused(true);
	}
	readyDoc();
	activeMenu();
	SmoothScroll({
		stepSize: 80,
		animationTime: 600,
		frameRate: 120,
		touchpadSupport: true,
		fixedBackground: false,
	});
});

function renderAjax(products, order, reinitCost = false) {
	if (reinitCost === false) {
		order.html("");
	}
	let allCost = 0,
		allDiscount = 0;
	if (products.length == 0) {
		order.html($(".product-ajax-not-exists").html());
		order.parent().find(".bottom").hide();
	} else {
		order.parent().find(".bottom").show();
		let tpl = $(".product-ajax-item").html();
		let productsLength = products.length;
		for (let i = 0; i < productsLength; i++) {
			var tmp = tpl;
			let price = 0,
				oldPrice = 0;
			let count =
				typeof products[i]["cart"] !== "undefined" &&
				typeof products[i]["cart"]["count"] !== "undefined"
					? parseInt(products[i]["cart"]["count"])
					: 1;
			products[i]["Cena-rub"] = (
				(parseFloat(`${products[i]["Cena"]}`) / window.rubData) *
				count
			).toFixed(0);
			Object.keys(products[i]).forEach((key) => {
				if (key == "attrs") return;
				let value = products[i][key];
				if (key == "Cena") {
					// const renderValue = parseFloat((parseFloat(value)/window.rubData * count).toFixed(0));
					value = parseFloat((parseFloat(value) * count).toFixed(0));
					products[i].Cena = value;
					price += value;
					value = value.toFixed(2).replace(/[.,]00$/, "");
				} else if (key == "oldPrice") {
					value = parseFloat(value) * count;
					products[i].oldPrice = value;
					oldPrice += value;
					value = value.toFixed(2).replace(/[.,]00$/, "");
				}
				tmp = tmp.replace(new RegExp("{ajax-" + key + "}", "g"), value);
			});
			tmp = tmp.replace(
				new RegExp('{ajax-short-descr(|="(.+?)"(|,"(.+?)"))}', "g"),
				function (d, s1, to, s2, add) {
					if (typeof add === "undefined") {
						add = "";
					}
					return to > 0
						? products[i]["Opisanie"].substr(0, to) +
								"" +
								(products[i]["Opisanie"].length > to ? add : "")
						: products[i]["Opisanie"];
				}
			);
			tmp = tmp.replace(
				new RegExp("{ajax-cart_id}", "g"),
				products[i].cart.cart_id
			);
			tmp = tmp.replace(
				new RegExp("{ajax-count}", "g"),
				products[i].cart.count
			);
			tmp = tmp.replace(new RegExp("{ajax-tip}", "g"), products[i].Tip);
			tmp = tmp.replace(
				new RegExp("test-uniq-link", "g"),
				products[i].alt_zagolovok
			);
			tmp = addBanner(products[i], tmp);
			if (reinitCost === false) {
				order.append(tmp);
			}
			allCost += parseFloat(price);
			allDiscount += parseFloat(oldPrice);
		}
		console.log("products", products);
		allCost = allCost.toFixed(2).replace(/[.,]00$/, "");
		// console.warn('allCost calc', allCost)
		allDiscount = allDiscount.toFixed(2).replace(/[.,]00$/, "");
		if (reinitCost === false) {
			shopReinit();
		}
	}
	return {
		allCost,
		allDiscount,
		products,
	};
}
window.activeStepOrder = {};
window.deliveryFields = 3;
var phoneCompleted;

function orderPage() {
	if ($(".product-view>.conain>.left.order .products .elem").length > 0) {
		$(".product-view>.conain>.left.order > .step[data-step='1']").addClass(
			"active"
		);
		$(".product-view>.conain>.left.order > .step[data-step='2']").addClass(
			"active"
		);
		$(".product-view>.conain>.left.order > .step[data-step='3']").addClass(
			"active"
		);
		$(".product-view>.conain .block.total button").removeAttr("disabled");
		// $(".product-view.order>.conain>.right .step[data-step='3']").addClass('active');
	} else {
		$(".product-view>.conain>.left.order > .step[data-step='1']").removeClass(
			"active"
		);
		$(".product-view>.conain>.left.order > .step[data-step='2']").removeClass(
			"active"
		);
		$(".product-view>.conain>.left.order > .step[data-step='3']").removeClass(
			"active"
		);
		$(".product-view>.conain .block.total button").attr("disabled", "disabled");
	}

	jQuery("body")
		.off("click", ".like-input")
		.on("click", ".like-input", function () {
			jQuery(".select-area").toggleClass("active");
		});

	jQuery("body")
		.off("click", ".select-area > span")
		.on("click", ".select-area > span", function () {
			var text = jQuery(this).text();
			var val = jQuery(this).attr("data-value");
			jQuery("#area").val(val);
			jQuery("#area").change();
			jQuery("span.like-input").html(text);
			jQuery(this).parent().removeClass("active");
		});

	window.totalOrderPrice = jQuery(
		".product-view.order>.conain>.right .total .head .total_cart b"
	).html();
	$("#phone").mask("+38(099) 999-9999", {
		placeholder: "_",
		completed: function () {
			/*orderNextStep(activeStepOrder, 2, 10);*/ phoneCompleted = true;
		},
	});
	$(".product-view>.conain>.left.order .step[data-step]:not(.mobile)").each(
		(iElem, elem) => {
			activeStepOrder[iElem] = 0;
			const id = $(elem).attr("data-step");
			const required = $(elem).find(".required");
			for (let i = 0; i < required.length; i++) {
				$(required[i])
					.find(":input")
					.on("input change", (e) => {
						if ($(e.target).val().length == 0) {
							if (activeStepOrder[iElem] != 0) {
								activeStepOrder[iElem]--;
							}
							$(e.target).removeAttr("active");
							const required = $(e.target)
								.parents("[data-step]")
								.find(".required");
							orderNextStep(activeStepOrder, iElem, required.length);
							console.warn(
								"elem MINUS",
								activeStepOrder[iElem],
								$(e.target).val()
							);
						} else if ($(e.target).attr("active") != "true") {
							console.warn("elem plus before", activeStepOrder[iElem]);
							activeStepOrder[iElem]++;
							console.warn("elem plus after", activeStepOrder[iElem]);
							$(e.target).attr("active", "true");
							console.log(activeStepOrder[iElem]);
							const required = $(e.target)
								.parents("[data-step]")
								.find(".required");
							orderNextStep(activeStepOrder, iElem, required.length);
						}
						if ($(required[i]).find(":input").hasClass("phoneInput")) {
							orderNextStep(activeStepOrder, 2, 10);
						}
					});
				if ($(required[i]).find("input").val().length > 0) {
					activeStepOrder[iElem]++;
				}
			}
			if (iElem > 0) {
				$(elem)
					.find("input + label")
					.on("click", (e) => {
						if (
							$(e.target).attr("for") == "private_house" ||
							$(e.target).attr("for") == "vip_deliv"
						) {
							orderNextStep(activeStepOrder, iElem, 1);
						} else {
							setTimeout(
								(activeStepOrder, iElem) => {
									activeStepOrder[iElem]++;
									orderNextStep(activeStepOrder, iElem, 1);
								},
								200,
								activeStepOrder,
								iElem
							);
						}
					});
			}
			orderNextStep(activeStepOrder, iElem, required.length);
		}
	);
	$(".product-view>.conain>.left.order :input").each((i, elem) => {
		console.log(elem);
		tapEvent(elem);
	});
	$(".product-view>.conain>.left.order :input").on("tap", (e) => {
		e.preventDefault();
		$(
			".product-view>*>.left.order .block.mobile, .product-view>.left.order .block.mobile"
		).addClass("activeKeyboard");
	});
	$(".product-view>.conain>.left.order").on("touchmove", (e) => {
		$(
			".product-view>*>.left.order .block.mobile, .product-view>.left.order .block.mobile"
		).removeClass("activeKeyboard");
	});
	$("#time_send_after, #time_send_now").on("change", () => {
		if ($("#time_send_now").prop("checked")) {
			window.dateCheckTimer = false;
			window.isSetTime = false;
			window.isSetDate = false;
		}
		if ($("#time_send_now").prop("checked") || window.dateCheckTimer) {
			// $(".product-view>.conain>.left.order .step[data-step='3']").addClass("active");
			// $(".product-view.order>.conain>.right .step[data-step='3']").addClass('active');
		}
		if ($("#time_send_after").prop("checked")) {
			window.dateCheckTimer = 0;
			window.checkDateNextStep = 0;
			console.log(test);
			let time;
			if (test <= 0) {
				// День уже закончился
				time = new Date().getTime();
				$(".timepicker").val(time);
				$(".timepickers2").trigger("click");
				window.checkDateNextStep = 1;
			} else if (test > hoursToNextDay) {
				// День не закончился
				time = new Date().getTime();
				$(".timepicker").val(time);
				$(".timepickers").trigger("click");
				window.checkDateNextStep = 2;
			} else {
				// День практически закончился
				$(".timepicker").trigger("click");
				window.checkDateNextStep = 1;
			}
			$("body")
				.off("checkDataDate")
				.on("checkDataDate", (e) => {
					console.log("checkDataDate ");
					if (e.originalEvent.doType == "set") {
						window.dateCheckTimer++;
						if (window.checkDateNextStep == window.dateCheckTimer) {
							window.activeStepOrder[1] = 1;
							orderNextStep(window.activeStepOrder, 2, 1);
						}
					}
				});
			$("body")
				.off("checkTimeDate")
				.on("checkTimeDate", (e) => {
					console.log("checkTimeDate trigger", e.originalEvent.doType);
					if (e.originalEvent.doType == "set") {
						window.dateCheckTimer++;
						if (
							window.checkDateNextStep == window.dateCheckTimer ||
							window.checkDateNextStep == window.dateCheckTimer + 1
						) {
							window.activeStepOrder[1] = 1;
							orderNextStep(window.activeStepOrder, 2, 1);
						}
					}
				});
			$("body")
				.off("checkDateFaild")
				.on("checkDateFaild", (e) => {
					console.log("err");
					$("[for='time_send_now']").click();
					$(".hide_elem *").val("");
				});
			jQuery(".step.step2-fields").show();
			jQuery(".step.step2-fields .input").show();
			jQuery(".step.step2-fields .input:not(.classic)").hide();
		}
		if (
			$("#time_send_now").prop("checked") ||
			$("#time_send_now").prop("checked")
		) {
			window.deliveryFields = 3;
			jQuery(".step.step2-fields").show();
			jQuery(".step.step2-fields .input").show();
			jQuery(".step.step2-fields .input:not(.classic)").hide();
			//jQuery(".area-block").removeClass("hidden")
			jQuery("#area").removeAttr("disabled");
		}
	});

	$("#private_house").on("change", () => {
		if ($("#private_house").prop("checked")) {
			window.deliveryFields = 2;
			jQuery(".step.step2-fields").show();
			jQuery(".step.step2-fields .input").show();
			jQuery(".step.step2-fields .input:not(.private-house) input").val("");
			jQuery(".step.step2-fields .input:not(.private-house)").hide();
			$("#vip_deliv").prop("checked", false);
			$("#vip_deliv").attr("disabled", true);
			$("#vip_deliv").parent().addClass("disabled");
		} else {
			$("#vip_deliv").attr("disabled", false);
			$("#vip_deliv").parent().removeClass("disabled");
			jQuery(".step.step2-fields .input").hide();
			jQuery(".step.step2-fields .input.classic").show();
		}
	});

	$("#vip_deliv").on("change", () => {
		if ($("#vip_deliv").prop("checked")) {
			window.deliveryFields = 4;
			jQuery(".step.step2-fields").show();
			jQuery(".step.step2-fields .input").show();
			jQuery(".step.step2-fields .input:not(.vip)").hide();
		} else {
			jQuery(".step.step2-fields .input").hide();
			jQuery(".step.step2-fields .input.classic").show();
		}
		if (
			$("#vip_deliv").prop("checked") &&
			$("#private_house").prop("checked")
		) {
			window.deliveryFields = 2;
			jQuery(".step.step2-fields").show();
			jQuery(".step.step2-fields .input").show();
			jQuery(".step.step2-fields .input:not(.private-house)").hide();
		}
	});
	$("[name='time_send']").on("change", () => {
		// for(let p = 0; p < $(".products .elem").length; p++) {
		//     if($(".products .elem").eq(p).attr("data-product-tip") == "SALE") {
		//         pickupSale = false;
		//         break;
		//     } else {
		//         pickupSale = true;
		//     }
		// }
		if ($("#pickup").prop("checked")) {
			//if(pickupSale) {
			pickupCalc();
			//}
			window.deliveryFields = 0;
			jQuery(".step.step2-fields").hide();
			jQuery(".step.address").slideDown(300);
			//jQuery(".area-block").addClass("hidden")
			jQuery("#area").attr("disabled", "disabled");
		} else {
			jQuery(".step.address").slideUp(300);
			jQuery(
				".product-view.order>.conain>.right .total .head .total_cart b"
			).html(window.totalOrderPrice);
			//jQuery(".area-block").removeClass("hidden")
			jQuery("#area").removeAttr("disabled");
		}
	});
}

function pickupCalc() {
	var chprice = parseInt(
		jQuery(
			".product-view.order>.conain>.right .total .head .total_cart b"
		).html()
	);
	console.warn("change");
	var newPrice = 0;
	jQuery("form.product-view [data-selfdeilerysale]").each(function (i, e) {
		newPrice += parseInt(jQuery(e).attr("data-selfdeilerysale"));
	});
	console.log("newPrice", newPrice);
	jQuery(".product-view.order>.conain>.right .total .head .total_cart b").html(
		newPrice
	);
}

//var pickupSale = true;
var testmode = false;
window.totalOrderPrice = 0;

function orderNextStep(activeStepOrder, id, length) {
	console.log(activeStepOrder, id, length, "DATa");
	console.warn(`active ${activeStepOrder[id]}, ${id}, ${length}`);
	let doIng = { step1: false, step2: false, step3: false, resp: false };
	if (loadedPage == "order3.html") {
		if (activeStepOrder[0] == 5) {
			doIng.step1 = true;
			//console.log($(".product-view.order>.conain>.right .step[data-step='2']"))
			$(".product-view>.conain>.left.order .step[data-step='2']").addClass(
				"active"
			);
			$(".product-view.order>.conain>.right .step[data-step='2']").addClass(
				"active"
			);
			if (activeStepOrder[1] >= 1) {
				doIng.step2 = true;
				if ($("#time_send_now").prop("checked")) {
					window.dateCheckTimer = false;
					window.isSetTime = false;
					window.isSetDate = false;
				}
				if ($("#time_send_now").prop("checked") || window.dateCheckTimer) {
					$(".product-view>.conain>.left.order .step[data-step='3']").addClass(
						"active"
					);
					$(".product-view.order>.conain>.right .step[data-step='3']").addClass(
						"active"
					);
				} else {
					window.dateCheckTimer = 0;
					window.checkDateNextStep = 0;
					console.log(test);
					let time;
					if (test <= 0) {
						// День уже закончился
						time = new Date().getTime();
						$(".timepicker").val(time);
						$(".timepickers2").trigger("click");
						window.checkDateNextStep = 1;
					} else if (test > hoursToNextDay) {
						// День не закончился
						time = new Date().getTime();
						$(".timepicker").val(time);
						$(".timepickers").trigger("click");
						window.checkDateNextStep = 2;
					} else {
						// День практически закончился
						$(".timepicker").trigger("click");
						window.checkDateNextStep = 1;
					}
					$("body")
						.off("checkDataDate")
						.on("checkDataDate", (e) => {
							console.log("checkDataDate ");
							if (e.originalEvent.doType == "set") {
								window.dateCheckTimer++;
								if (window.checkDateNextStep == window.dateCheckTimer) {
									window.activeStepOrder[1] = 1;
									orderNextStep(window.activeStepOrder, 2, 1);
								}
							}
						});
					$("body")
						.off("checkTimeDate")
						.on("checkTimeDate", (e) => {
							console.log("checkTimeDate trigger", e.originalEvent.doType);
							if (e.originalEvent.doType == "set") {
								window.dateCheckTimer++;
								if (
									window.checkDateNextStep == window.dateCheckTimer ||
									window.checkDateNextStep == window.dateCheckTimer + 1
								) {
									window.activeStepOrder[1] = 1;
									orderNextStep(window.activeStepOrder, 2, 1);
								}
							}
						});
					$("body")
						.off("checkDateFaild")
						.on("checkDateFaild", (e) => {
							console.log("err");
							$("[for='time_send_now']").click();
							$(".hide_elem *").val("");
						});
					activeStepOrder[1] = 0;
					$(
						".product-view>.conain>.left.order .step[data-step='3']"
					).removeClass("active");
					$(
						".product-view.order>.conain>.right .step[data-step='3']"
					).removeClass("active");
					$(".product-view.order>.conain>.right .total .checkbox input").attr(
						"disabled",
						"disabled"
					);
					$(".product-view.order>.conain>.right .submit button").attr(
						"disabled",
						"disabled"
					);
				}
			}
			if (activeStepOrder[2] >= 1) {
				doIng.step3 = true;
				$(
					".product-view.order>.conain>.right .total .checkbox input"
				).removeAttr("disabled");
				$(".product-view.order>.conain>.right .submit button").removeAttr(
					"disabled"
				);
			}
		} else {
			$(".product-view.order>.conain>.right .step[data-step='2']").removeClass(
				"active"
			);
			$(".product-view.order>.conain>.right .step[data-step='3']").removeClass(
				"active"
			);
			$(".product-view>.conain>.left.order .step[data-step='2']").removeClass(
				"active"
			);
			$(".product-view>.conain>.left.order .step[data-step='3']").removeClass(
				"active"
			);
			$(".product-view.order>.conain>.right .total .checkbox input").attr(
				"disabled",
				"disabled"
			);
			$(".product-view.order>.conain>.right .submit button").attr(
				"disabled",
				"disabled"
			);
		}
	} else {
		var re = /_/gi;
		console.log(
			"TEST HERE",
			$(".cusname").val().length > 0 &&
				jQuery("#phone").val().replace(re, "").length >= 17
		);
	}
	if (doIng.step1 && doIng.step2 && doIng.step3) {
		doIng.resp = true;
	}
	console.log(doIng.step1, doIng.step2, doIng.step3);
	var event = new Event("checkOrder");
	event.doIng = doIng;
	document.body.dispatchEvent(event);
	return doIng;
}
let pageNow = 1;
function addBanner(data, tmp) {
	if (typeof data.Tip === "undefined" || data.Tip === null) {
		return tmp;
	}
	let tips = data.Tip.split(",");
	let ret = "";
	for (let i = 0; i < tips.length; i++) {
		switch (tips[i]) {
			case "NEW":
				ret += '<div class="new">NEW</div>';
				break;
			case "HOT":
				ret += '<div class="hot">HOT</div>';
				break;
			case "SALE":
				ret += '<div class="sale">SALE</div>';
				break;
			case "VEG":
				ret += '<div class="veg">VEG</div>';
				break;
		}
	}
	if (typeof data.allDiscount !== "undefined" && data.allDiscount > 0) {
		ret += '<div class="discount">-' + data.allDiscount + "%</div>";
	}
	tmp = tmp.replace(new RegExp("{banners}", "g"), ret);
	return tmp;
}
const findPositionProducts = () => {
	window.scrollTopProduct = {};
	$(".products .product-item, .actions-item").each(function (i, elem) {
		const offset = $(elem).offset();
		if (typeof offset === "undefined" || typeof offset.top === "undefined") {
			return;
		}
		const top = offset.top - (i == 0 ? 200 : 300);
		window.scrollTopProduct[top] = elem;
	});
};
var lockLoad = false;
function loadProducts(elem, load, filtered, pager) {
	(async (elem) => {
		const max = window.doLoadMax;
		console.log("pages", pages);
		if ($(".catalog-products .products .more a").css("display") == "none") {
			$(".catalog-products .products .more a").show(300);
		}
		let products, pages;
		const {
			data: productsList,
			pages: { pagesList },
		} = await filterAndGet(
			filtered,
			pager || {
				//await getProductsFiltered({
				page: pageNow,
				max,
			}
		);
		console.log("productsList", productsList);
		products = productsList;
		pages = pagesList;
		var tpl = $("#product").html();
		if (!tpl) {
			return;
		}
		for (var i = 0; i < products.length; i++) {
			var tmp = tpl;
			/*Object.keys(products[i]).forEach((key) => {
                if(key!="attrs") return;
                console.warn(products[i], 'attr');
                let attrListTpl = ''
                if(products[i].attrs) {
                    try {
                        products[i].attrs = JSON.parse(products[i].attrs)
                        console.warn(products[i].attrs, 'attr');
                        const num = products[i].attrs.AttributesProducts_list.length
                        if(num>0) {
                            products[i].Cena = parseFloat((typeof(products[i].attrs.AttributesProducts_list[num-1])!=="undefined" && typeof(products[i].attrs.AttributesProducts_list[num-1].price)!=="undefined" ? products[i].attrs.AttributesProducts_list[num-1].price : products[i].Cena));
                            const attrListTmp = '<span class="btn btn-attr" data-attr="{id}" data-price="{price}">{title}</span>'
                            for(let z=0;z<products[i].attrs.AttributesProducts_list.length;z++) {
                                let attrValue = attrListTmp
                                attrValue = attrValue.replace(new RegExp("{id}", "g"), `${z+1}`);
                                attrValue = attrValue.replace(new RegExp("{price}", "g"), (typeof(products[i].attrs.AttributesProducts_list[z].price)!=="undefined" ? products[i].attrs.AttributesProducts_list[z].price : ""));
                                attrValue = attrValue.replace(new RegExp("{title}", "g"), (typeof(products[i].attrs.AttributesProducts_list[z].name)!=="undefined" ? products[i].attrs.AttributesProducts_list[z].name : ""));
                                attrListTpl += attrValue
                            }
                        }
                    } catch(e) {
                        console.error(e);
                    }
                }
                const value = '<div class="attrs">'+attrListTpl+'</div>'
                tmp = tmp.replace(new RegExp("{ajax-attrs}", "g"), value)
            })*/
			Object.keys(products[i]).forEach((key) => {
				//if(key=="attrs") return;
				tmp = tmp.replace(
					new RegExp("{ajax-" + key + "}", "g"),
					products[i][key]
				);
			});
			tmp = tmp.replace(new RegExp("{ajax-attrs}", "g"), "");
			tmp = tmp.replace(
				new RegExp('{ajax-short-descr(|="(.+?)"(|,"(.+?)"))}', "g"),
				function (d, s1, to, s2, add) {
					if (typeof add === "undefined") {
						add = "";
					}
					return to > 0
						? products[i]["Opisanie"].substr(0, to) +
								"" +
								(products[i]["Opisanie"].length > to ? add : "")
						: products[i]["Opisanie"];
				}
			);
			tmp = tmp.replace(
				new RegExp("test-uniq-link", "g"),
				products[i].alt_zagolovok
			);
			tmp = addBanner(products[i], tmp);
			elem.append(tmp);
		}
		activatedAttrsBtn();
		findPositionProducts();
		shopReinit();

		var id = $(".product-view>.left .container .info .attrs .btn.active").attr(
			"data-attr"
		);
		$(
			".product-view>.left .addition_product .btn[data-additionals-size]"
		).hide();
		$(
			".product-view>.left .addition_product .btn[data-additionals-size='" +
				id +
				"']"
		).show();
		$(".product-item").each(function (i, elem) {
			var id = $(elem).find(".zIndex2 .attrs span.active").attr("data-attr");
			$(elem)
				.find(".zIndex2 .addition_product .btn[data-additionals-size]")
				.hide();
			$(elem)
				.find(
					".zIndex2 .addition_product .btn[data-additionals-size='" + id + "']"
				)
				.show();
		});

		let isHide = false;

		if (pages !== undefined) {
			for (let i = 0; i < pages.length; i++) {
				if (pages[i].now == 1 && pages.length == pageNow) {
					isHide = true;
					lockLoad = true;
				}
			}
			if (pages.length == 0) {
				$(".catalog-products .products .more a").hide(300);
				lockLoad = true;
			}

			console.warn("isHide", isHide, pages);
			if (isHide || pages.length == 0) {
				$(".catalog-products .products .more a").hide(300);
				$(".catalog-products .products .more").removeClass("show");
			}
		} else {
			$(".catalog-products .products .more a").hide(300);
			$(".catalog-products .products .more").addClass("hidden");
		}

		//        if(typeof($('.catalog-products')[0])!=="undefined") {
		//            const adminOffset = $("html").css("paddingTop");
		//            const heightNav = $(".hide_header").outerHeight() + (parseFloat(adminOffset));
		//            new StickySidebar('.menu', {
		//                topSpacing: heightNav,
		//                containerSelector: '.catalog-products'
		//            });
		//        }
	})(elem);
}
function onlyLoadProducts(elem, filter, load) {
	console.warn("loadProducts", load);
	console.log("test1");
	(async (elem) => {
		const max = window.doLoadMax;
		if ($(".catalog-products .products .more a").css("display") == "none") {
			$(".catalog-products .products .more a").show(300);
		}
		const {
			data: products,
			pages: { pages },
		} = await getProductsOnlyFiltered({
			filter,
			page: pageNow,
			max,
		});
		console.log(products);
		var tpl = $("#product").html();
		if (!tpl) {
			return;
		}
		for (var i = 0; i < products.length; i++) {
			var tmp = tpl;
			Object.keys(products[i]).forEach((key) => {
				tmp = tmp.replace(
					new RegExp("{ajax-" + key + "}", "g"),
					products[i][key]
				);
			});
			tmp = tmp.replace(
				new RegExp('{ajax-short-descr(|="(.+?)"(|,"(.+?)"))}', "g"),
				function (d, s1, to, s2, add) {
					if (typeof add === "undefined") {
						add = "";
					}
					return to > 0
						? products[i]["Opisanie"].substr(0, to) +
								"" +
								(products[i]["Opisanie"].length > to ? add : "")
						: products[i]["Opisanie"];
				}
			);
			tmp = tmp.replace(
				new RegExp("test-uniq-link", "g"),
				products[i].alt_zagolovok
			);
			tmp = addBanner(products[i], tmp);
			elem.append(tmp);
		}
		findPositionProducts();
		console.log("test2");
		shopReinit();
		let isHide = false;
		for (let i = 0; i < pages.length; i++) {
			if (pages[i].now == 1 && pages.length == pageNow) {
				isHide = true;
				lockLoad = true;
			}
		}

		if (pages.length == 0) {
			$(".catalog-products .products .more a").hide(300);
			lockLoad = true;
		}

		console.warn("isHide", isHide, pages);
		if (isHide || pages.length == 0) {
			$(".catalog-products .products .more a").hide(300);
			$(".catalog-products .products .more").removeClass("show");
		}
		//        if(typeof($('.catalog-products')[0])!=="undefined") {
		//            const adminOffset = $("html").css("paddingTop");
		//            const heightNav = $(".hide_header").outerHeight() + (parseFloat(adminOffset));
		//            new StickySidebar('.menu', {
		//                topSpacing: heightNav,
		//                containerSelector: '.catalog-products'
		//            });
		//        }
	})(elem);
}
jQuery(".c-modal__close").on("click", function () {
	jQuery(".c-modal--search").removeClass("is-active");
	jQuery(".c-search__input-wrapper").removeClass("is-shown");
	jQuery(".js-modal-close").removeClass("is-shown");
	jQuery(".c-search__results").html("");
	jQuery(".js-search-input").trigger("reset");
});

var serchTpl = jQuery(".search-tpl").html();

jQuery("body").on("input", ".js-search-input", function () {
	var blocks = "";
	var v = $(this).val();
	if (v.length == 0) {
		asrch = 0;
		jQuery(".c-search__results").html("");
	} else {
		(async (v, serchTpl) => {
			let { data: infoAll } = await productsSearch(v);
			for (var i = 0; i < infoAll.length; i++) {
				var tpln = serchTpl;
				tpln = tpln.replace(/\{search-pid\}/g, infoAll[i].sId);
				tpln = tpln.replace(/\{search-img\}/g, infoAll[i].Kartinka_produkcii);
				tpln = tpln.replace(/\{search-name\}/g, infoAll[i].Zagolovok);
				tpln = tpln.replace(
					/\{search-alt_zagolovok\}/g,
					infoAll[i].alt_zagolovok
				);
				if (infoAll[i].Skidka > 0) {
					tpln = tpln.replace(/\{search-price\}/g, infoAll[i].allDiscount);
				} else {
					tpln = tpln.replace(/\{search-price\}/g, infoAll[i].Cena);
				}
				blocks += tpln;
			}
			// jQuery("body > .container > article > .events > .right.tpl").html("");
			jQuery(".c-search__results").html(blocks);
			for (var i = 0; i < infoAll.length; i++) {
				(function (i) {
					setTimeout(function () {
						jQuery($(".c-search__card")[i]).addClass("is-active");
					}, 60);
				})(i);
			}
			new SimpleBar($(".js-search-results")[0]);
		})(v, serchTpl);
	}
});

var App = /** @class */ (function () {
	function App() {
		var tl = new TimelineMax({
			repeat: -1,
		});
		tl.to([".pizzaOutline", ".pizzaMask"], 7, {
			rotation: 360,
			svgOrigin: "61 61",
			ease: Linear.easeNone,
		}).to(
			".whole",
			7,
			{
				rotation: -45,
				svgOrigin: "61 61",
				ease: Linear.easeNone,
			},
			0
		);
	}
	return App;
})();
TweenMax.set("svg", {
	visibility: "visible",
});

var app = new App();
TweenMax.globalTimeScale(4);

document.querySelectorAll("[href='#'],.cart,.pseudo-cart").forEach((elem) => {
	elem.addEventListener("click", (e) => {
		e.preventDefault();
		if (typeof e.target.dataTime !== "undefined") {
			clearTimeout(e.target.dataTime);
		}
		e.target.classList.add("active-btn");
		e.target.dataTime = setTimeout(() => {
			e.target.classList.remove("active-btn");
		}, 800);
	});
});

document.body.addEventListener("cartAdd", function (t) {
	animChange(t.detail.cart);
});
document.body.addEventListener("cartAddByElement", function (t) {
	console.warn(t.detail.cart);
	console.log("ADDTOCART");
	animChange(t.detail.cart);
});

let sublistData = {};
document.querySelectorAll(".sublist").forEach((elem) => {
	let onActive = false;
	elem.addEventListener("mouseenter", (e) => {
		if (
			e.target.closest(".sublist") == null ||
			e.target.closest(".sublist").querySelector(".list") == null
		) {
			return;
		}
		if (Object.keys(sublistData).length > 0) {
			Object.keys(sublistData).forEach((id) => {
				clearTimeout(id);
			});
			sublistData = {};
		}
		onActive = true;
		var elem = e.target.closest(".sublist").querySelector(".list");
		if (!elem) {
			return;
		}
		elem.classList.add("hover");

		const arr = e.target.closest(".sublist").querySelectorAll(".list > *");
		const arrR = [...arr];
		for (let i = 0; i < arrR.length; i++) {
			const idT = setTimeout(
				(el) => {
					if (onActive == true) {
						el.classList.add("hover");
					}
				},
				i * 600,
				arrR[i]
			);
			sublistData[i] = idT;
		}
		console.log(sublistData);
	});
	elem.addEventListener("mouseleave", (e) => {
		if (
			e.target.closest(".sublist") == null ||
			e.target.closest(".sublist").querySelector(".list") == null
		) {
			return;
		}
		console.log(sublistData);
		if (Object.keys(sublistData).length > 0) {
			Object.keys(sublistData).forEach((id) => {
				clearTimeout(id);
			});
			sublistData = {};
		}
		onActive = false;

		const arr = e.target.closest(".sublist").querySelectorAll(".list > *");
		const arrR = [...arr];
		const reversed = arrR.reverse();
		for (let i = 0; i < reversed.length; i++) {
			const idT = setTimeout(
				(el) => {
					if (onActive == false) {
						el.classList.remove("hover");
					}
				},
				i * 600,
				reversed[i]
			);
			sublistData[i] = idT;
		}
		const idT = setTimeout(
			(e) => {
				if (onActive == false) {
					console.log("remove");
					e.target
						.closest(".sublist")
						.querySelector(".list")
						.classList.remove("hover");
				}
			},
			reversed.length * 600,
			e
		);
		sublistData[reversed.length] = idT;
	});
});

var halfPage = 0;

jQuery(document).ready(function () {
	if (loadedPage == "") {
		if (!window.isHomeLoading) {
			$("body").addClass("productsloading");
		}
		if ($(window).width() < 991) {
			$(".catalog .category a,.catalog-products .onMobileHover a.picca")
				.off("click")
				.on("click", function (e) {
					e.preventDefault;
					window.location.href = "/category/picca/";
					return false;
				});
		}
	} else {
		halfPage = jQuery("body").height() / 2;
	}
	var btnOffset = 0;

	jQuery("body").on("productsFiltered productsFilteredAndGet", function () {
		console.log("etetete", $(".catalog-products .products .more a").length);
		setTimeout(() => {
			console.log("etetete2", $(".catalog-products .products .more a").length);
			if ($(".catalog-products .products .more a").length > 0) {
				btnOffset = $(".catalog-products .products .more a").offset().top;
				halfPage = jQuery("body").height() / 2;
				$("body").removeClass("productsloading");
				console.log("productsloading");
				lockLoad = false;
			}
		}, 1000);
	});
	/*setTimeout(() => {
      if($(window).scrollTop() >= halfPage){
        jQuery('.call-icon').addClass("scroll")
      } else {
        jQuery('.call-icon').removeClass("scroll")
      }
        }, 3000)*/
	setTimeout(function () {
		if ($(".catalog-products .products .more a").length > 0) {
			btnOffset = $(".catalog-products .products .more a").offset().top;
			var elem = $(".catalog-products .products .list");
			$(window).scroll(function () {
				console.log($(".catalog-products .products .list .product").length > 0);
				if (
					($(window).scrollTop() + $(window).height()) * 1.1 >= btnOffset &&
					!lockLoad &&
					$(".catalog-products .products .list .product").length > 0
				) {
					$(".catalog-products .products .more a").click();
					// loadProducts(elem, "more");
					lockLoad = true;
				}
			});
		}

		// $(window).scroll(function(){
		//       console.log("IF" , $(window).scrollTop() >= halfPage)
		//     if($(window).scrollTop() >= halfPage){
		//       jQuery('.call-icon').addClass("scroll")
		//     } else {
		//       jQuery('.call-icon').removeClass("scroll")
		//     }
		// })
		jQuery(".call-icon.scroll").on("click", function () {
			// if(jQuery('.call-icon').hasClass('scroll')){
			jQuery("body, html").animate({ scrollTop: 0 }, 1000);
			return false;
			// }
		});
	}, 2000);
});

$("body")
	.off("click", "article>.seoDescription>.mainText:not(:empty)+.link")
	.on(
		"click",
		"article>.seoDescription>.mainText:not(:empty)+.link",
		function () {
			$(this).addClass("hide");
			console.warn($(this).next().removeClass("hider"));
		}
	);

if (
	typeof localStorage.getItem("mobileNoty") != "undefined" &&
	localStorage.getItem("mobileNoty") !== null
) {
	jQuery("body")
		.removeClass("doubleTapNotyVisible")
		.addClass("doubleTapNotyHidden");
	jQuery(".doubletapnoty").hide();
} else {
	jQuery("body").addClass("doubleTapNotyVisible");
}

jQuery(".doubletapnoty").on("click", function () {
	jQuery(this).hide();
	jQuery("body")
		.removeClass("doubleTapNotyVisible")
		.addClass("doubleTapNotyHidden");
	localStorage.setItem("mobileNoty", true);
});

$(".comments form").on("submit", function (e) {
	$.ajax({
		url: "/addReview",
		type: "POST",
		data: $(this).serialize(),
		success: function success() {
			_alert({
				title: "Комментарий оставлен",
				desc: "",
				time: 5000,
			});
			document.forms.comment.reset();
		},
		error: function error() {
			_alert({
				title: "Комментарий не оставлен",
				desc: "",
				time: 5000,
				typeMess: "error",
			});
			document.forms.comment.reset();
		},
	});
	return false;
	e.preventDefault();
});

$(document).ready(function () {
	$(".stars .star").hover(function () {
		let name = $(this).parents(".row").attr("data-row-name");
		let rate = $(this).data("value");
		let i = 0;
		$('.row[data-row-name="' + name + '"] .stars .star').each(function () {
			i++;
			if (i <= rate) {
				$(this).addClass("active");
			} else {
				$(this).removeClass("active");
			}
		});
	});

	$(".stars .star").mouseleave(function () {
		let name = $(this).parents(".row").attr("data-row-name");
		let rate = $('input[name="rating[' + name + ']"]').val();
		rate = parseInt(rate);
		let i = 0;
		$('.row[data-row-name="' + name + '"] .stars .star').each(function () {
			i++;
			if (i <= rate) {
				$(this).addClass("active");
			} else {
				$(this).removeClass("active");
			}
		});
	});

	$(".stars .star").click(function () {
		let name = $(this).parents(".row").attr("data-row-name");
		$('input[name="rating[' + name + ']"]').val($(this).data("value"));
	});
	$("body").on("click", ".cart+.mini-cart .elem .remove", function () {
		$(
			".product-view>*>.left.order .elem[data-cart-id=" +
				$(this).parents("[data-product-parent]").attr("data-cart-id") +
				"] .remove"
		).click();
	});
});
